<template>
  <div>
    <artwork-text-drawer
      v-model="textDrawerOpen"
      :artwork="textDrawerArtwork"
      :text-summary="textDrawerText"
      @text-saved="onTextSaved"
      @representative-saved="onRepresentativeSaved"
    ></artwork-text-drawer>
    <v-navigation-drawer width="520" temporary fixed right hide-overlay dark style="top: 80px" class="px-2 navbar"
      v-model="options_c">
      <v-layout row pt-3 pb-2>
        <v-flex>
          <v-subheader class="font-weight-regular display-1 white--text">
            Options
            <v-spacer></v-spacer>
            <a @click="closeOptions()" class="font-weight-regular display-1 white--text">x</a>
            <!-- <v-btn small flat @click="clearFilters()">X</v-btn> -->
          </v-subheader>
          <v-divider></v-divider>
        </v-flex>
      </v-layout>

      <tag-filter @updateFilterTags="updateFilterTags"></tag-filter>

      <!-- <v-subheader class="font-weight-regular display-1 white--text">
        Options
        <v-spacer></v-spacer>
        <a @click="clear_selection" v-if="this.selected.length>0">X</a>
      </v-subheader>-->
      <!-- <div class="pl-3 pt-3 pb-2 font-weight-regular display-1 white--text">Options</div>
      <v-spacer></v-spacer>
      <div class="right pt-3 pb-2 font-weight-regular display-1 white--text">X</div>-->
      <v-divider class="mx-3 pb-0 mb-0 white"></v-divider>

      <!-- <v-layout row xs12>
        <v-flex xs12>
          <v-subheader class="white--text" mb-0 pb-0>Sorting</v-subheader>
          <v-flex xs6 mx-3 class="mt-0 pt-0">
            <v-radio-group v-model="sort" :mandatory="false" class="mt-0 pt-0">
              <v-radio color="white" label="By Title" value="title"></v-radio>
              <v-radio
                color="white"
                label="By Artist"
                value="full_name"
              ></v-radio>
              <v-radio
                color="white"
                label="By Accession No."
                value="accession_number"
              ></v-radio>
            </v-radio-group>
          </v-flex>
          <v-subheader class="white--text mb-0 pb-0"
            >Secondary sorting</v-subheader
          >
          <v-flex xs6 mx-3 mt-0 pt-0>
            <v-radio-group
              v-model="subsort"
              :mandatory="false"
              class="mt-0 pt-0"
            >
              <v-radio
                color="white"
                label="Production Date"
                value="production_date_new"
              ></v-radio>
              <v-radio
                color="white"
                label="Classification"
                value="classification"
              ></v-radio>
              <v-radio
                color="white"
                label="Accession Number"
                value="accession_number"
              ></v-radio>
            </v-radio-group>
          </v-flex>
        </v-flex>
      </v-layout> -->

      <!-- <v-layout row pt-0 mt-0 xs12>
        <v-flex xs12>
          <v-subheader class="white--text">
            Selection
            <v-spacer></v-spacer>
            <a @click="clear_selection" v-if="this.selected.length > 0"
              >Clear Selection</a
            >
          </v-subheader>
        </v-flex>
      </v-layout> -->

      <!-- <v-divider class="mx-3 pb-0 mb-0 white"></v-divider> -->

      <v-list>
        <!-- <v-list-tile class="pl-0 ml-4 white--text">
          <v-list-tile-content>
            <v-list-tile-title> <a class="white--text" @click="addSelectedToSelection">Add selected Artworks to Selection</a> </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>-->
        <!-- <v-divider class="mx-3 pb-0 mb-0 white"></v-divider> -->
        <v-list-tile class="pl-0 ml-4 white--text">
          <v-list-tile-content>
            <v-list-tile-title>
              <a class="white--text" @click="addAllToSelection">Add all shown Artworks to Selection</a>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider class="mx-3 pb-0 mb-0 white"></v-divider>
        <v-list-tile class="pl-0 ml-4 white--text" v-if="this.selected.length > 0">
          <v-list-tile-content>
            <v-list-tile-title>
              <a class="white--text" @click="clear_selection">Clear Selection</a>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <!-- <v-divider class="mx-3 pb-0 mb-0 white"></v-divider> -->
        <v-list-tile class="pl-0 ml-4 white--text">
          <v-list-tile-content>
            <v-list-tile-title>
              <a class="white--text" @click="addFilteredToSelection">Add Search Results to Selection</a>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <!-- <v-list-tile class="pl-0 ml-4" @click="$router.push({ path: child.path })">
          <v-list-tile-content>
            <v-list-tile-title> Change Selected Artworks </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>-->

        <!-- <v-list-group style="height:200px; overflow: scroll;"> -->

        <!-- v-shortkey='a' @shortkey="$router.push({ path: 'item.path' })"  -->
        <!-- <v-list-tile slot="activator" no-action>
            <v-list-tile-content>
              <v-list-tile-title> Add Selection to List </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-list-tile class="pl-0 ml-4" v-for="l in artworks_selections" :key="l.id">
            <v-list-tile-content >
              <v-list-tile-title> {{ l.name }} </v-list-tile-title>
            </v-list-tile-content>
        </v-list-tile>-->
        <!-- </template> -->

        <!-- <v-list-tile @click="reset_store()" target='_blank'> -->
        <!-- <v-list-tile-action>
              <v-icon>reset</v-icon>
        </v-list-tile-action>-->
        <!-- <v-list-tile-content>
              <v-list-tile-title>Reset local storage</v-list-tile-title>
            </v-list-tile-content>
        </v-list-tile>-->
        <!-- </v-list-group> -->
      </v-list>

      <v-divider class="mx-3 pb-0 mb-0 white"></v-divider>

      <!-- <v-layout row pt-0 mt-0>
        <v-flex >
          <v-subheader class="white--text">
            Filter
            <v-spacer></v-spacer>
            <v-btn small flat @click="clearFilters()">Reset Filter</v-btn>
          </v-subheader>
        </v-flex>
      </v-layout>-->

      <!-- <v-list>
        <v-list-tile class="pl-0 ml-2" v-for="tc in this.tag_categories" :key="tc.id">
            <v-checkbox
              v-model="selected_tag_categories"
              :label="tc.name"
              :value="tc.id"
              :color="tc.color"
              hide-details
            ></v-checkbox>
        </v-list-tile>
      </v-list>-->
    </v-navigation-drawer>

    <!-- // TAG FILTERS  -->
    <!-- <v-btn
      @click="switchSwitch"
      dark
      class="elevation-0 ml-4"
      tile
      outlined
      small
    >
      <v-icon left small class="mr-2">mdi-tag-multiple</v-icon>Filter by tags
      <v-icon right v-if="!showTags">mdi-chevron-down</v-icon>
      <v-icon right v-if="showTags">mdi-chevron-up</v-icon>
    </v-btn> -->

    <v-card class="mt-0 mb-3 mx-4 py-0 elevation-1" v-if="show_tag_filter">
      <v-card-text>
        <v-container fluid pt-0>
          <v-layout row wrap>
            <v-flex xs12 sm6 md3 v-for="tc in this.$store.state.tag_categories" v-bind:key="tc.id">
              <v-checkbox small v-model="selected_tag_categories" v-bind:label="tc.name" v-bind:value="tc.id"
                v-bind:color="tc.color" hide-details></v-checkbox>
            </v-flex>
          </v-layout>
        </v-container>
        <v-flex xs12 class="mx-4" v-if="this.selected_tag_categories.length > 0">
          <v-select label="Select Tags" :items="select_tags" v-model="selected_tags" item-text="name" item-value="id"
            multiple chips max-height="auto" autocomplete @change="save_currently_selected_tags">
            <template slot="selection" slot-scope="data">
              <v-chip close @input="data.parent.selectItem(data.item)" :selected="data.selected"
                class="chip--select-multi" :key="JSON.stringify(data.item)"
                :color="`${data.item.color} lighten-5`"><span class="mx-0 px-0"
                  v-if="data.item.concept_tag == 1">&starf;</span>{{ data.item.name }}</v-chip>
            </template>

            <template slot="item" slot-scope="data">
              <template v-if="typeof data.item !== 'object'">
                <v-list-tile-content v-text="data.item"></v-list-tile-content>
              </template>
              <template v-else>
                <v-list-tile-avatar icon>
                  <v-icon :color="data.item.color">people</v-icon>
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title v-html="data.item.name"></v-list-tile-title>
                  <v-list-tile-sub-title v-html="data.item.group"></v-list-tile-sub-title>
                </v-list-tile-content>
              </template>
            </template>
          </v-select>
        </v-flex>
      </v-card-text>
      <v-card-title primary-title class="mt-0">
        <!-- <v-switch v-model="show_tag_filter" @change="switchSwitch" label="Show Filters" class="pb-3 ml-4" hide-details></v-switch> -->
        <v-spacer></v-spacer>
        <v-btn right @click="clearFilters" v-if="selected_tag_categories.length > 0">Reset Filters</v-btn>
      </v-card-title>
    </v-card>

    <!-- <v-container fluid my-4 xs12 mx-4>
      <v-flex xs3 v-for="tc in this.tag_categories" v-bind:key="tc.id">
        <v-checkbox small
          v-model="selected_tag_categories"
          v-bind:label="tc.name"
          v-bind:value="tc.id"
          v-bind:color="tc.color"
          hide-details
        ></v-checkbox>
      </v-flex>
    </v-container>-->

    <!-- ASSIGN TAGS -->
    <!-- <v-btn @click="showTags=!showTags" color="success" class="elevation-0 ml-3">Tags management <v-icon right>chevron-down</v-icon></v-btn> -->
    <!-- <v-btn v-if="this.selected.length > 0" @click="showTags = !showTags" dark class="elevation-0 ml-4" tile outlined
      small>
      <v-icon left small class="mr-2">mdi-tag-multiple</v-icon>Assign Tags to
      {{ this.selected.length > 1 ? 'these' : 'this' }}
      {{ this.selected.length }} Artwork{{
        this.selected.length > 1 ? 's' : ''
      }}:

      <v-icon right v-if="!showTags">mdi-chevron-down</v-icon>
      <v-icon right v-if="showTags">mdi-chevron-up</v-icon>
    </v-btn> -->
    <transition name="fade" mode="out-in" @beforeLeave="beforeLeave" @enter="enter" @afterEnter="afterEnter">
      <div v-if="showTags && this.selected.length > 1" class="mx-2 mt-0 dark">
        <!-- <v-btn rounded icon class="elevation-0 right mr-3" @click="save_tag_form_display=!save_tag_form_display">
          <v-icon color="black">mdi-tag-plus</v-icon>
        </v-btn>-->
        <v-layout column class="mx-3 pa-4 mb-5" elevation-1>
          <!-- <v-flex mx-5 mt-5> -->
          <v-flex v-if="save_tag_form_display == true" style="background-color: #f3fff5" pb-3 px-3 pt-0>
            <div class="green--text text--darken-1 headline pl-3 mt-4">
              Add a New Tag
            </div>
            <v-flex mx-2 mb-0>
              <v-layout row mt-4>
                <v-flex xs12 mx-2>
                  <v-text-field box class="input-group" v-model="tag_title" label="Tag Title"></v-text-field>
                </v-flex>
              </v-layout>
              <!-- <v-divider class="mt-3"></v-divider> -->
            </v-flex>
            <v-flex mt-3 right>
              <!-- <v-spacer></v-spacer> -->
              <v-btn color="success" :disabled="!this.tag_title.length > 0" @click="create_tag">Save</v-btn>
              <v-btn color="fail" @click="close_save_tag_form()">Cancel</v-btn>
            </v-flex>
          </v-flex>
          <v-flex mx-2 align="center">
            <v-autocomplete :filter="customFilter" multiple chips v-model="selected_tags_assign"
              :items="select_tags_assign" :item-text="
                (item) =>
                  `${item.name} / ${item.category ? item.category : 'General'}`
              " label="Click to select Tags " item-text="name" item-value="id"
              hint="Select tags to assign to selected artworks">
              <template v-slot:prepend-inner>
                <v-icon class="ml-2" @click="showFilter = false">style</v-icon>
              </template>
              <template v-slot:item="data">
                <!-- <v-list two-line> -->
                <v-list-tile-content>
                  <v-list-tile-title><span class="mr-2 px-0" v-if="data.item.concept_tag == 1">&starf;</span>{{
                    data.item.name
                  }}</v-list-tile-title>
                  <v-list-tile-sub-title class="text-xs-right"
                    v-html="data.item.category ? data.item.category : 'General'"></v-list-tile-sub-title>
                  <v-divider></v-divider>
                </v-list-tile-content>
                <!-- <v-flex class="text-xs-left">
                {{}}
                </v-flex>
                <v-flex class="text-xs-right">
                {{`${}`}}
                </v-flex> -->
                <!-- </v-list> -->
              </template>
            </v-autocomplete>
          </v-flex>
          <v-flex mx-0 my-3>
            <v-btn dark @click="assignTagsToMultipleArtworks()" :disabled="
              !(selected_tags_assign.length > 0 && selected.length > 0)
            ">Assign {{ selected_tags_assign.length }} tags to
              {{ selected.length }} selected artworks</v-btn>
          </v-flex>
          <!-- </v-flex> -->
        </v-layout>
      </div>
    </transition>

    <!-- GALLERY -->
    <div v-if="this.$store.state.view == 'gallery'" class="mx-4 pt-0 mt-5 elevation-0" style="column-count: 4">
      <div class="carda" v-for="a in table_artworks" :key="a.id">
        <v-hover>
          <v-card slot-scope="{ hover }" class="mx-auto elevation-0" max-width="600">
            <!-- <img v-bind:src="'http://tb-cms.org/data/artwork/' + a.id + '/' + a.top_photo_id + '_th.jpg'"/> -->
            <v-img :src="topPhotoUrl(a, 'middle')">
              <!-- <v-expand-transition> -->
              <div v-if="hover" class="
                  px-4
                  py-3
                  subheading
                  transition-fast-in-fast-out
                  grey
                  darken-4
                  v-card--reveal
                  white--text
                ">
                <div class="font-weight-regular white--text mb-0 text-xs-left">
                  {{ a.artist ? a.artist.name : a.name }}
                </div>
                <!-- <br>{{ a.title }}, {{ a.production_date_new }} -->
                <router-link class="
                    font-weight-regular
                    body-2
                    mb-2
                    white--text
                    text-xs-left
                  " :to="{
                    name: 'EditArtwork',
                    params: { id: a.id, artwork: a },
                    path: `/artworks/edit/${a.id}`,
                  }">
                  <v-tooltip top v-if="hasArtworkSeries(a)">
                    <v-icon
                      slot="activator"
                      small
                      class="series-indicator series-indicator--gallery mr-1"
                    >collections_bookmark</v-icon>
                    <span>{{ artworkSeriesLabel(a) }}</span>
                  </v-tooltip>
                  <v-tooltip top v-if="hasCurrentExhibitions(a)">
                    <v-icon
                      slot="activator"
                      small
                      class="on-view-indicator on-view-indicator--gallery mr-1"
                    >visibility</v-icon>
                    <span>{{ currentExhibitionsLabel(a) }}</span>
                  </v-tooltip>
                  <span :class="{ 'red--text': a.deaccessioned }"
                    v-html="`${a.title}, ${a.production_date_new}`"></span>
                </router-link>
                <div v-if="a.dim_f_json" class="body-2 mb-2" v-html="a.dim_f_json"></div>
                <div v-if="a.artwork_location_id && a.artwork_location_id != 465" class="body-2">
                  {{ get_location_name(a.artwork_location_id) }}
                </div>
                <!-- v-model="selected[a.id]" -->
                <!-- <v-checkbox outline class="pt-3 pl-0 ml-0 align-start justify-start row fill-height" color="white" hide-details
                  :value="a.id"
                  v-model="selected_g"
                  @change="save_currently_selected_gallery(selected_g,a)"
                ></v-checkbox>-->
              </div>
              <!-- </v-expand-transition> -->
            </v-img>
          </v-card>
        </v-hover>
      </div>
    </div>

    <!-- BATCH CHANGE -->
    <v-dialog v-model="dialog" max-width="900px">
      <!-- <v-btn :disabled="this.selected.length<1" slot="activator" color="primary" class="mb-2">Change Selected Artworks</v-btn> -->
      <v-card dark style="
          background: rgb(2, 0, 36);
          background: linear-gradient(
            180deg,
            rgba(0, 0, 0, 1) 0%,
            rgba(33, 33, 33, 0.95) 100%
          );
        ">
        <v-card-title class="mb-0 pb-0 px-4 mx-1 title">
          Batch change parameters of
          {{ this.selected.length > 1 ? 'these' : 'this' }}
          {{ this.selected.length }} Artwork{{
            this.selected.length > 1 ? 's' : ''
          }}:
        </v-card-title>
        <div class="px-4 mx-1 mt-2 grey--text">
          Current location is not an artwork parameter. Use the Change Location workflow for single or batch moves.
        </div>

        <v-card-text class="pt-0 mt-0 px-0">
          <v-container grid-list-xs pt-2>
            <v-layout wrap>
              <v-flex elevation-0 xs12 pl-2 pt-3 mt-2 px-2 mx-1 mb-2 style="
                  height: 100px;
                  overflow: auto;
                  clear: both;
                  background-color: #222222;
                ">
                <!-- background-color: #222222; -->
                <!-- <h3 class="header mb-2">
                  Change parameters of
                  {{ this.selected.length > 1 ? "these" : "this" }}
                  {{ this.selected.length }} Artwork
                  {{ this.selected.length > 1 ? "s" : "" }}:
                </h3> -->
                <ul>
                  <li v-for="a in this.selected" :key="a.id">
                    <b>{{ a.title }}</b>
                    - {{ a.full_name }} -
                    <b>{{ a.accession_number }}</b>
                  </li>
                </ul>
              </v-flex>

              <v-flex xs12 my-1 mx-1 elevation-0 style="background-color: #444">
                <v-expansion-panel xs12 class="elevation-5" v-model="panel">
                  <!-- TYPE OF WORK -->
                  <v-expansion-panel-content xs12 class="px-1 py-1" :style="panel == 0 ? 'background-color: #333' : ''">
                    <div slot="header" class="title">
                      Type of Work
                      <span v-if="edited_artwork.type_of_work_id" class="right mr-4">{{
                        get_type_of_work(edited_artwork.type_of_work_id)
                      }}</span>
                    </div>
                    <v-radio-group v-model="edited_artwork.type_of_work_id" class="pt-0 mt-0 pl-4">
                      <v-radio color="#aaa" v-for="vs in constants['TYPES_OF_WORK']" :key="vs.id" :value="vs.id"
                        :label="vs.name"></v-radio>
                    </v-radio-group>
                  </v-expansion-panel-content>

                  <!-- LOCATION -->
                  <!-- <v-expansion-panel-content
                    class="px-1 py-1"
                    :style="panel == 1 ? 'background-color: #333' : ''"
                  >
                    <div slot="header" class="title">
                      Location
                      <span class="right mr-4 body-2"
                        >{{ artwork_location_log.change_date }} -
                        {{
                          get_location_name(
                            artwork_location_log.artwork_location_id
                          )
                        }}
                        - {{ artwork_location_log.storage.toUpperCase() }} -
                        {{ artwork_location_log.copy }} -
                        <small>{{ artwork_location_log.note }} </small> -
                      </span>
                    </div>
                    <v-flex class="xs12 ml-0 mr-2 pl-4 pr-4 pt-4 pb-3 mb-2">
                      <v-flex class="xs12">
                        <v-autocomplete
                          v-model="artwork_location_log.artwork_location_id"
                          label="New Location"
                          :items="this.$store.getters.locationsSorted"
                          item-text="name"
                          item-value="id"
                          cache-items
                          dense
                        ></v-autocomplete>
                      </v-flex>
                      <v-flex class="xs12">
                        <v-text-field
                          v-model="artwork_location_log.note"
                          name="note"
                          label="Note"
                        ></v-text-field>
                      </v-flex>
                      <v-flex class="xs12 md6 mb-0 pt-0">
                        <v-btn-toggle
                          mandatory
                          v-model="artwork_location_log.storage"
                          active-class="activeToggle"
                        >
                          <v-btn value="in" small flat class="px-3">
                            <v-icon small>call_received</v-icon> IN
                          </v-btn>
                          <v-btn value="out" small flat class="px-3">
                            OUT <v-icon small>call_made</v-icon>
                          </v-btn>
                        </v-btn-toggle>
                      </v-flex>

                      <v-flex xs12 mt-3 mb-3>
                        <v-btn-toggle
                          mandatory
                          v-model="artwork_location_log.copy"
                          active-class="activeToggle"
                        >
                          <v-btn small flat class="px-3" value="artwork"
                            >Artwork
                          </v-btn>
                          <v-btn
                            small
                            flat
                            class="px-3"
                            value="master_physical"
                            >Master Physical
                          </v-btn>
                          <v-btn
                            small
                            flat
                            class="px-3"
                            value="archive_master"
                            >Archive Master
                          </v-btn>
                          <v-btn small flat class="px-3" value="access_copy"
                            >Access Copy
                          </v-btn>
                        </v-btn-toggle>
                      </v-flex>
                      <v-flex xs12 sm6 md4>
                        <v-menu
                          v-model="menu2"
                          :return-value.sync="
                            artwork_location_log.change_date
                          "
                          ref="menu2"
                          :close-on-content-click="true"
                          :nudge-right="40"
                          lazy
                          landscape
                          transition="scale-transition"
                          offset-y
                          full-width
                          min-width="290px"
                        >
                          <v-text-field
                            v-model="artwork_location_log.change_date"
                            slot="activator"
                            label="Date"
                            prepend-icon="event"
                            readonly
                          ></v-text-field>
                          <v-date-picker
                            persistent
                            v-model="artwork_location_log.change_date"
                            @input="
                              $refs.menu2.save(
                                artwork_location_log.change_date
                              )
                            "
                          ></v-date-picker>
                        </v-menu>
                      </v-flex>
                      <v-flex class="xs12"></v-flex>
                    </v-flex>

                  </v-expansion-panel-content> -->

                  <!-- LOCATION NOTES -->
                  <v-expansion-panel-content xs12 class="px-1 py-1" :style="panel == 2 ? 'background-color: #333' : ''">
                    <div slot="header" class="title">
                      Location Notes
                      <span v-if="edited_artwork.location_notes" class="right mr-4">{{
                        edited_artwork.location_notes
                      }}</span>
                    </div>
                    <v-textarea clearable class="mx-4" auto-grow rows="1"
                      v-model="edited_artwork.location_notes"></v-textarea>
                    <v-checkbox color="white" class="ml-4" label="Append to current content of the field, if any"
                      v-model="append_notes"></v-checkbox>
                  </v-expansion-panel-content>

                  <!-- CREDIT -->
                  <v-expansion-panel-content xs12 class="px-1 py-1" :style="panel == 3 ? 'background-color: #333' : ''">
                    <div slot="header" class="title">
                      Credit
                      <span v-if="edited_artwork.credit" class="right mr-4 overflow-hidden">{{
                        edited_artwork.credit
                      }}</span>
                    </div>
                    <v-textarea clearable class="mx-4" auto-grow rows="1" v-model="edited_artwork.credit"></v-textarea>
                    <v-checkbox color="white" class="ml-4" label="Append to current content of the field, if any"
                      v-model="append_credit"></v-checkbox>
                  </v-expansion-panel-content>

                  <!-- VISA STATUS -->
                  <v-expansion-panel-content xs12 class="px-1 py-1" :style="panel == 4 ? 'background-color: #333' : ''">
                    <div slot="header" class="title">
                      Visa Status
                      <span v-if="edited_artwork.visa_status" class="right mr-4">{{
                        get_visa_status(edited_artwork.visa_status)
                      }}</span>
                    </div>
                    <v-radio-group class="mx-4" :column="false" v-model="edited_artwork.visa_status">
                      <v-radio color="black" v-for="vs in this.constants.VISA_STATUSES" :key="vs.id" :value="vs.id"
                        :label="vs.name"></v-radio>
                    </v-radio-group>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-flex>

              <!-- <v-flex elevation-1 xs12 ml-1 pt-0 pb-4 px-4 mx-3>
                <h3 class="header mx-3 mt-4 mb-2">Things that will change:</h3>
                <ul>
                  <li v-if="edited_artwork.type_of_work">
                    <b>
                      <u>Type of Work</u>
                    </b> will be changed to:
                    <b>{{get_type_of_work(edited_artwork.type_of_work)}}</b>
                  </li>
                  <li v-if="edited_artwork.artwork_location_id">
                    <b>Location</b> will be changed to:
                    <b>{{get_location_name(edited_artwork.artwork_location_id)}}</b>
                  </li>
                  <li v-if="edited_artwork.location_notes">
                    <b>Location Notes</b> will be changed to:
                    <b>{{edited_artwork.location_notes}}</b>
                  </li>
                  <li v-if="edited_artwork.credit">
                    <b>Credit</b> will be changed to:
                    <b>{{edited_artwork.credit}}</b>
                  </li>
                  <li v-if="edited_artwork.visa_status">
                    <b>Visa Status</b> will be changed to:
                    <b>{{get_visa_status(edited_artwork)}}</b>
                  </li>
                </ul>
              </v-flex>-->
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions class="pr-5 pb-4">
          <v-spacer></v-spacer>
          <v-btn color="black" flat @click.native="dialog = false">Cancel</v-btn>
          <v-btn color="white" flat @click.native="updateArtworks" :disabled="
            !Object.values(edited_artwork).some((x) => x !== null && x !== '')
          ">Modify all selected Artworks</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- <v-menu open-on-hover bottom offset-y class="pr-4">
      <v-btn slot="activator" @click="save_selection">SAVE SELECTION</v-btn>
      <v-list>
        <v-list-tile v-for="l in saved_lists" :key="l.id" @click="save_selection">
          <v-list-tile-title>
            <router-link to="item.path">SAVE TO: {{l.title}}</router-link>
          </v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>-->

    <location-change-dialog :showDialog="show_change_location_dialog" @hideDialog="show_change_location_dialog = false"
      :selected="selected"></location-change-dialog>

    <attach-tag-to-artworks-dialog v-if="show_attach_tag_dialog" @switchOffDialog="show_attach_tag_dialog = false"
      :selected="selected"></attach-tag-to-artworks-dialog>

    <v-card v-if="this.$store.state.view == 'list'" class="mx-2 py-0 elevation-0">
      <v-layout v-if="this.$store.state.showSearch && !this.showFilter" class="fill-height row mr-0 mb-4 justify-end">
        <!-- <v-btn @click="clear_selection" v-if="this.selected.length>0">CLEAR SELECTION</v-btn>
        <v-btn @click="select_all">SELECT ALL</v-btn>-->
        <v-spacer></v-spacer>

        <!-- SEARCH -->
        <div style="width:550px; border: 1px solid rgba(0, 0, 0, 0.7); " class="mr-2 ml-3 pl-3 round">
          <!-- label="Search by tags" -->
          <!-- item-text="label" -->
          <v-autocomplete
            v-model="selectedTags"
            :items="tagNames"
            item-value="id"
            placeholder="Search by tags"
            :filter="customTagFilter"
            multiple
            chips
            deletable-chips
            small-chips
            clearable
            flat
            hide-details
            single-line 
            full-width
            hide-selected
            prepend-inner-icon="tags"
          >
            <template v-slot:item="{ item }">
              <v-list-tile-content>
                <v-list-tile-title >{{item.section}} - {{ item.subcategory }} <b>#{{ item.name }}</b> </v-list-tile-title>
              </v-list-tile-content>
            </template>
            <template v-slot:selection="data">
              <v-chip
                :selected="data.selected"
                small
                dense
                color="primary"
                text-color="white"
                close
                class="chip--select-multi"
                @input="remove(data.item.id)"
              >
                {{ data.item.label }}
              </v-chip>
            </template>
          </v-autocomplete>
        </div>
        <!-- <v-text-field
          v-if="this.$store.state.showSearch && !this.showFilter" 
          v-model="searchTags" 
          prepend-inner-icon="tags"
          @click:prepend-inner="showFilter = true" 
          :background-color="
            selected_filter_tags.length > 0 || (search && search.length > 0)
            ? '#f5f5f5'
            : ''
          " 
          style="height:20px;" 
          clearable 
          hide-details
          single-line 
          flat
          dense
          full-width
          >
        </v-text-field> -->
        <div style="width:350px; height: 58px; border: 1px solid rgba(0, 0, 0, 0.7);  ">

          <v-text-field
            v-if="this.$store.state.showSearch && !this.showFilter" 
            v-model="search" 
            placeholder="Search by title, acq.no., artist, ID, etc."
            prepend-inner-icon="search"
            @click:prepend-inner="showFilter = true" 
            :background-color="
              selected_filter_tags.length > 0 || (search && search.length > 0)
              ? '#f5f5f5'
              : ''
            " 
            style="height:20px;" 
            clearable 
            hide-details
            single-line 
            flat
            dense
            full-width
            >
            <!-- label="Search"  -->
            <!-- density="compact" -->
          <!-- class="px-2 mr-2 elevation-" -->
          </v-text-field>
        </div>

        <!-- search all button -->
        <div class=" mx-2 mt-1 py-0" v-if="this.$store.state.showSearch" style="width:40px;">
          <v-btn icon @click="searchAllToggle" class="mx-0 py-0">
            <v-icon v-if="searchAll" small color="red">check_circle</v-icon>
            <v-icon v-else color="black" small dark>check_circle_outline</v-icon>
          </v-btn>
        </div>

        <!-- show only selection button -->
        <div class=" mt-1 pr-0 mr-0" v-if="
          this.$store.state.currentSelection.length > 0 || this.table_artworks.length == 0
        " style="width:60px;">
          <!-- :class="{
              xs12: showFilter,
              xs1: !showFilter,
              'text-xs-right mr-2 mt-2 py-0': true,
            }" -->
          <v-btn icon @click="toggleSelection" class="mx-0 py-0">
            <v-icon v-if="showSelection" small color="red">auto_awesome_motion</v-icon>
            <v-icon v-else color="black" small dark>auto_awesome_motion</v-icon>
            {{ this.$store.state.currentSelection.length }}
          </v-btn>
        </div>
        <!-- <div class="ml-0 mr-0" style="border-bottom: 1px solid rgba(0, 0, 0, 0.1)"></div> -->

      </v-layout>
      <!-- <v-divider></v-divider> -->

      <v-layout row flex mt-4 v-if="selected.length > 0" >

        <v-btn class="ml-3 mr-0 mb-4 pr-3" small v-if="!this.show_attach_tag_dialog" color="black" @click="toggleShowAttachTagDialog"
          dark>
          <v-icon left small class="mr-2">mdi-autorenew</v-icon>
          Assign Tags to 
          {{ this.selected.length }} Artwork{{
            this.selected.length > 1 ? 's' : ''
          }}:
        </v-btn>

        <v-btn class="ml-3 mr-0 mb-4 pr-3" small color="black" @click="showBatchUpdateDialog"
          dark>
          <v-icon left small class="mr-2">mdi-autorenew</v-icon>
          Batch update 
          {{ this.selected.length }} Artwork{{
            this.selected.length > 1 ? 's' : ''
          }}:
        </v-btn>
        <v-btn dark @click="show_change_location_dialog = true" class="ml-3 mr-0 mb-4 pr-3"
          small>
          <v-icon class="mr-2" small>edit_location</v-icon>Change location of
          selected
        </v-btn>

        <v-btn class="ml-3 mr-0 mb-4 pr-3" small color="red" @click="resetSelected" dark>
          <v-icon left small class="mr-1">mdi-close</v-icon>Clear Selection
        </v-btn>
      </v-layout>

      <!-- OWNERSHIPS -->
      <v-layout row mt-3 mx-2 v-if="this.$route.fullPath == '/artworks/ownership/deaccession'">
        <span>
          <v-menu offset-y :close-on-content-click="true" class="text-xs-right mx-4 my-0 py-0 align-center">
            <template v-slot:activator="{ on }">
              <v-btn small icon color="black" dark v-on="on" class="text-xs-right mx-0 mt-2 my-0 py-0">
                <v-icon small>supervisor_account</v-icon>
              </v-btn>
            </template>
            <v-list value="1">
              <v-list-tile v-for="(item, index) in ownerships" :key="index.id" @click="toggleOwnership(item)">
                <!-- <v-list-tile-avatar v-if="item.id==sorting">
                    <v-icon>mdi-sort-ascending</v-icon>
                  </v-list-tile-avatar> -->
                <!-- <v-list-tile-avatar v-else>
                    <v-icon></v-icon>
                  </v-list-tile-avatar> -->
                <v-list-tile-title>{{ item.name }}</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </span>
        <span class="text-xs-left mt-2 pt-1 title">
          {{ selectedOwnership.name }}
        </span>
        <v-spacer></v-spacer>
              <v-btn
          small dark
          color="black"
          class="mr-3 mt-3"
          @click="exportToExcel"
        >
          <v-icon small left>mdi-file-excel</v-icon>
          Export to Excel
        </v-btn>

      </v-layout>

      <!-- commissions filter -->
      <!-- <v-flex class="mt-4 mr-3 ml-3 mb-2" v-if="this.$route.fullPath == '/artworks/ownership/commissions'">
        <v-btn-toggle v-model="commissions">
          <v-btn small flat key="group1" class="px-2" input-value="all" value="all">
            <span> All </span>
          </v-btn>
          <v-btn small flat key="group2" class="px-2" input-value="tba" value="tba">
            <span> TBA21 Commissions </span>
          </v-btn>
          <v-btn small flat key="group3" class="px-2" input-value="com_academy" value="com_academy">
            <span> TBA21 Academy Commissions </span>
          </v-btn>
          <v-btn small flat key="group4" class="px-2" input-value="not" value="not">
            <span> NOT Acquired </span>
          </v-btn>
        </v-btn-toggle> -->


        <v-layout row mt-4 ml-2 align-center>
          <artwork-filter-menu v-model="facetSelections"></artwork-filter-menu>
          <artwork-row-view-menu v-model="rowView"></artwork-row-view-menu>
          <v-spacer></v-spacer>
          <v-btn
          small dark
          color="black"
          class="mr-3 mt-3"
          @click="exportToExcel"
        >
          <v-icon small left>mdi-file-excel</v-icon>
          Export to Excel
        </v-btn>
        </v-layout>

      <v-spacer></v-spacer>

      <!-- FILTER  BY TAGs -->
      <!-- <v-layout xs12 row wrap pt-0 pb-2> -->
      <!-- <v-flex xs12>
            <v-subheader class="font-weight-regular title white--text"> Tag filtering </v-subheader>
          </v-flex> -->

      <!-- d-flex
          py-0
          my-0 -->
      <span v-if="this.$store.state.showSearch && showFilter" class="px-2 flex xs10">
        <span v-if="selected_filter_tags.length > 1" class="pt-3 my-0 text-xs-left xs1">
          <v-btn @click="and = !and" small flat icon color="black" v-if="and" py-0 my-0>AND</v-btn>
          <v-btn @click="and = !and" small flat icon color="black" v-if="!and" py-0 my-0>OR</v-btn>
        </span>
        <!-- prepend-inner-icon="style" -->
        <!-- @click:prepend-inner="showFilter=false" -->
        <!-- :filter="customFilter"  -->
        <v-autocomplete xs10 :background-color="search && search.length > 0 ? '#fee' : ''"
          v-model="selected_filter_tags" 
          :items="tags" 
          :item-text="
            (item) =>
              `${item.name} / ${item.category ? item.category : 'General'}`
          " item-value="id" label="Filter by Tags" multiple chips clearable deletable-chips dense hide-details
          small-chips>
          <template v-slot:prepend-inner>
            <v-icon class="ml-2" @click="showFilter = false">style</v-icon>
          </template>
          <template v-slot:item="data">
            <!-- <v-list two-line> -->
            <!-- :class="{ 'red--text': data.item.concept_tag == 1 }" -->
            <v-list-tile-content>
              <v-list-tile-title><span class="mr-2 px-0" v-if="data.item.concept_tag == 1">&starf;</span>{{
                data.item.name
              }}</v-list-tile-title>
              <v-list-tile-sub-title v-if="data.item.concept_tag != 1" class="text-xs-right grey--text"
                v-html="data.item.category ? data.item.category : ''"></v-list-tile-sub-title>
              <v-divider></v-divider>
            </v-list-tile-content>
            <!-- <v-flex class="text-xs-left">
                {{}}
                </v-flex>
                <v-flex class="text-xs-right">
                {{`${}`}}
                </v-flex> -->
            <!-- </v-list> -->
          </template>
        </v-autocomplete>
        <!-- <v-flex xs12 class="white--text"> -->
        <!-- {{selected_filter_tags}} -->
        <!-- </v-flex> -->
        <!-- <v-flex v-for="(item, index) in tag_items" :key="index">
              <h3 class="white--text pl-3 pt-2">{{item.title}}</h3>
              <v-flex v-for="(a, index) in $store.state.artworks.slice(0,5)" :key="'a'+index">
                <v-checkbox class="mt-0 pl-3" :label="a[item.name]" v-model="selected_filter_tags" :value="item.tag+a[item.name]" color="white"></v-checkbox>
              </v-flex>
              <v-divider></v-divider>
            </v-flex> -->
      </span>

      <!--</v-layout> -->
      <!-- </v-card-title> -->

      <div class="ml-2 mr-3" style="border-bottom: 1px solid rgba(0, 0, 0, 0.1)"></div>
      <!-- must-sort -->
      <!-- :filter="customTableSearch" -->
      <v-data-table ref="dTable" 
        :loading="$store.state.loading_artworks"
        :headers-length="5" hide-headers :headers="headers"
        :items="table_artworks" 
        :search="search" 
        v-model="selected" 
        item-key="id" rows-per-page-text="Artworks per page"
        no-results-text="No Artworks match the criteria." no-data-text="No Artworks loaded." class="elevation-0 mx-3"
        :pagination.sync="p">
        <v-progress-linear v-slot:progress color="blue" indeterminate></v-progress-linear>

        <!-- select-all
        @change="save_currently_selected_all(selected)"-->
        <template slot="items" slot-scope="props">
          <tr class="pb-0 mb-0" style="border-top: 1px solid rgba(0, 0, 0, 0.5)">
            <td style="
                width: 20px !important;
                margin: 0px !important;
                padding: 0px !important;
              ">
              <v-checkbox class="pt-3 px-0 mx-0 align-start justify-start row fill-height" color="black" hide-details
                v-model="props.selected" @change="save_currently_selected(props.selected, props.item)"></v-checkbox>
            </td>
            <td style="
                text-align: center;
                vertical-align: text-top;
                width: 140px;
                padding: 7px 0 0 0;
              ">
              <img @error="imageUrlAlt" v-if="props.item.top_photo_id > 0" :src="topPhotoUrl(props.item)" style="width: 120px; margin: 10px" :class="{
  redBorder:
    props.item.top_photo &&
    (props.item.top_photo.width < 500 ||
      props.item.top_photo.height < 500),
}" />
              <!-- <img @error="imageUrlAlt"
                v-else-if=" [12,15,16].includes(props.item.ownership)"
                v-bind:src="
                  'http://tb-cms.org/data/artwork/gemini/' +
                    props.item.accession_number +
                    '.jpg'
                "
                style="width: 120px; margin: 10px"
              /> -->
              <img @error="imageUrlAlt" v-else :src="imageUrlAlt" style="width: 120px; margin: 10px" />
            </td>

            <td colspan="7" class="my-0 py-0 body-1 align-start justify-start row fill-height"
              style="vertical-align: top; padding: 7px 0 0 0">
              <table width="100%" style="padding-top: 25px" class="my-2 py-0 body-1 align-start justify-start row">
                <tr>
                  <td class="
                      body-1
                      align-start
                      justify-space-between
                      column
                      fill-height
                      pt-2
                      pb-0
                      mb-0
                      pl-2
                      pr-0
                    ">
                    <div class="
                        title
                        black--text
                        text-xs-left
                        mb-1
                        font-weight-thin
                      ">
                      {{
                        props.item.artist
                          ? props.item.artist.name
                          : props.item.name
                            ? props.item.name
                            : props.item.artist_name
                      }}
                    </div>
                    <!-- <v-btn
                      target="_blank"
                      icon
                      small
                      class="ml-0"
                      color="grey"
                      @click="
                        goToUrl(
                          'http://tb-cms.org/artworks/edit/' + props.item.id
                        )
                      "
                    >
                      <v-icon class small color="white">launch</v-icon>
                    </v-btn> -->
                    <!-- <v-btn
                      icon
                      small
                      class="ml-0"
                      color="black"
                      :to="{ name: 'EditArtwork', params: {id: props.item.id, artwork: props.item}, path: `/artworks/edit/${props.item.id}`}"
                    >
                      <v-icon class small color="white">launch</v-icon>
                    </v-btn>-->
                    <!-- <span>{{ props.item.title }}, {{ props.item.production_date_new }}</span> -->
                    <!-- <a target="_blank" :href="'http://tb-cms.org/artworks/edit/' + props.item.id" style="margin:10px;" icon><v-icon small class="mr-2 black--text">open_in_new</v-icon></a> -->

                    <router-link :to="{
                      name: 'EditArtwork',
                      params: { id: props.item.id, artwork: props.item },
                      path: `/artworks/edit/${props.item.id}`,
                    }">
                      <span :class="[
                        { 'red--text': props.item.deaccessioned },
                        'subheading',
                    ]" v-html="`<b>${props.item.title}</b>`"></span><span :class="[
  { 'red--text': props.item.deaccessioned },
  'subheading',
]" v-html="`${props.item.subtitle}`" v-if="props.item.subtitle"></span><span v-if="props.item.production_date_new"
                        :class="[
                          { 'red--text': props.item.deaccessioned },
                          'subheading',
                        ]" v-html="`<b>, ${props.item.production_date_new}</b>`"></span>
                    </router-link>
                    <v-tooltip top v-if="hasArtworkSeries(props.item)">
                      <v-icon
                        slot="activator"
                        small
                        class="series-indicator ml-2"
                      >collections_bookmark</v-icon>
                      <span>{{ artworkSeriesLabel(props.item) }}</span>
                    </v-tooltip>
                    <v-tooltip top v-if="hasCurrentExhibitions(props.item)">
                      <v-icon
                        slot="activator"
                        small
                        class="on-view-indicator ml-2"
                      >visibility</v-icon>
                      <span>{{ currentExhibitionsLabel(props.item) }}</span>
                    </v-tooltip>
                    <br />
                    <span class="mr-3">{{ props.item.accession_number }}</span>
                    <v-spacer class="mb-2"></v-spacer>
                    <artwork-text-row-details
                      v-if="rowView === 'texts'"
                      :artwork="props.item"
                      @add="openAddText"
                      @edit="openEditText"
                    ></artwork-text-row-details>
                    <artwork-netx-row-details
                      v-if="rowView === 'netx_images'"
                      :artwork="props.item"
                      :assets="netxReviewAssetsFor(props.item.id)"
                      :loading="netxReviewLoadingFor(props.item.id)"
                      :error="netxReviewErrorFor(props.item.id)"
                      :sync-state="netxReviewSyncFor(props.item.id)"
                      :sync-disabled="netxReviewSyncDisabledFor(props.item.id)"
                      @ensure="ensureNetxReviewArtwork"
                      @notice="setNetxReviewNotice(props.item.id, $event)"
                      @select="setNetxReviewSelection"
                      @sync="syncNetxReviewArtwork"
                    ></artwork-netx-row-details>
                    <template v-if="rowView === 'standard'">
                    <v-icon v-if="props.item.dim_f_json" small color="black">square_foot</v-icon>
                    <span v-if="props.item.dim_f_json">
                      {{ props.item.dim_f_json }}</span><br />
                    <!-- Dimensions: -->
                    <!-- <span> {{ dimension_formatted(props.item) }}</span> -->
                    <!-- <br /> -->
                    <div v-if="
                      props.item.artwork_location_id &&
                      props.item.artwork_location_id != 465
                    ">
                      <v-icon small color="black">edit_location</v-icon>
                      <!-- Location: -->
                      <span>
                        {{
                          get_location_name(props.item.artwork_location_id)
                        }}</span>
                    </div>
                    <!-- {{get_location_name(props.item.artwork_location_id)}} -->
                    <!-- DISABLED TAGS -->
                    <div v-if="props.item.tags && props.item.tags.length > 0 && 1==2">
                      <div class="pt-3 ml-0 pl-0">
                        <v-chip
                          color="black"
                          text-color="white"
                          v-for="t in props.item.tags"
                          :key="t.id"
                          small
                        >#{{ t.name }}</v-chip
                        >
                      </div>
                    </div>
                    </template>
                    <!-- <router-link :to="`/artist/view/${props.item.artist.id}`">{{ props.item.artist.full_name }}</router-link> -->
                  </td>
                </tr>
                <tr class="my-0 py-0" v-if="rowView === 'standard' && ((props.item.artwork_todos && props.item.artwork_todos.filter(
                          (at) => at.done != 1
                        ).length > 0) || props.item.visa_status == 3)">
                  <!-- <td> -->
                  <!-- <div class="mt-0"> -->
                  <!-- <router-link :to="{ name: 'EditArtwork', params: {id: props.item.id, artwork: props.item}, path: `/artworks/edit/${props.item.id}`}">
                        <v-icon small class="dense mr-2 black--text">edit</v-icon>
                  </router-link>-->
                  <!-- </div> -->
                  <!-- </td> -->
                  <td class="my-0 py-0 pr-0" style="text-align: right; width: 30px">
                    <v-chip v-if="props.item.visa_status == 3" text-color="white" color="red" small>F</v-chip>
                    <!-- <span
                      style="color:red"
                      v-if="props.item.visa_status==3"
                    >F</span>-->
                    <v-tooltip left color="black" v-if="
                      props.item.artwork_todos &&
                      props.item.artwork_todos.filter((at) => at.done != 1)
                        .length > 0
                    ">
                      <template #activator="data">
                        <v-chip color="#eee" small v-on="data.on">
                          <v-icon class="mr-3 small">mdi-format-list-numbered</v-icon>
                          {{
                            props.item.artwork_todos.filter(
                              (at) => at.done != 1
                            ).length
                          }}
                        </v-chip>
                      </template>
                      <div>
                        <div v-for="a in props.item.artwork_todos.filter(
                          (at) => at.done != 1
                        )" :key="a.id">
                          – {{ a.title }}
                          <br />
                        </div>
                      </div>
                    </v-tooltip>
                  </td>
                  <!-- <td style="width:30px;">{{ props.item.classification }}</td> -->
                  <!-- <td style="width:10px;">

                  </td>-->

                  <!-- <td style="width:10px;"> -->

                  <!-- <span style="color:green" v-if="props.item.open_todos_count>0">{{props.item.open_todos_count}}</span> -->
                  <!-- </td>                   -->
                </tr>
                <!-- ak zapnem chip tags, tak nerefreshuje collection menu -->
                <!-- <tr>
                  <td class="text-xs-right">
                    <v-chip
                      v-for="tag in props.item.tags"
                      v-bind:key="tag.id"
                      small
                      v-if="findTagExists(tag.id)"
                      >{{ findTagName(tag.id) }}</v-chip
                    >
                  </td>
                </tr> -->
              </table>
            </td>
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">Your search for "{{ search }}" found no
          results.</v-alert>
        <template slot="no-data">
          <index-load-state
            :loading="$store.state.loading_artworks"
            :error="$store.state.load_errors.artworks"
            empty-text="No Artworks Found."
          ></index-load-state>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import TagFilter from '@/components/artworks/TagFilter.vue'
import LocationChangeDialog from '../layout/toolbar_items/LocationChangeDialog.vue'
import AttachTagToArtworksDialog from '@/components/artworks/AttachTagToArtworksDialog.vue'
import constants from '@/data/constants'
import { serverBus } from '../../main'
import axios from '@/utils/apiClient'
import fields from '@/data/full_user_fields'
import XLSX from 'xlsx'
import ArtworkFilterMenu from './ArtworkFilterMenu'
import ArtworkRowViewMenu from './ArtworkRowViewMenu'
import ArtworkTextRowDetails from './ArtworkTextRowDetails'
import ArtworkTextDrawer from './ArtworkTextDrawer'
import ArtworkNetxRowDetails from './ArtworkNetxRowDetails'
import IndexLoadState from '@/components/general/IndexLoadState.vue'
import { filterArtworksByFacets } from './artworkFilterGroups'
import {
  artworkImportError,
  failedSelection,
  loadNetxImportRun,
  loadNetxAssets,
  pendingSelection,
  selectionError,
  startNetxArtworkImport,
  updateNetxSelection,
} from '@/utils/netxArtworkReview'
import { artworkImageUrl, mediaActive } from '@/utils/artworkMedia'

function dynamicSort(property, property2) {
  // var sortOrder = 1
  if (property[0] === '-') {
    // sortOrder = -1
    property = property.substr(1)
  }
  return function (a, b) {
    // var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
    if (a[property] > b[property]) return 1
    if (a[property] < b[property]) return -1
    if (a[property2] > b[property2]) return 1
    if (a[property2] < b[property2]) return -1
    // return result * sortOrder;
  }
}

const ARTWORK_ROW_VIEW_STORAGE_KEY = 'artworks-row-view'
const ARTWORK_ROW_VIEWS = ['standard', 'texts', 'netx_images']

function savedArtworkRowView() {
  try {
    const saved = window.localStorage.getItem(ARTWORK_ROW_VIEW_STORAGE_KEY)
    return ARTWORK_ROW_VIEWS.includes(saved) ? saved : 'standard'
  } catch (error) {
    return 'standard'
  }
}

function persistArtworkRowView(view) {
  try {
    window.localStorage.setItem(ARTWORK_ROW_VIEW_STORAGE_KEY, view)
  } catch (error) {
    // Ignore storage restrictions and keep the setting for this session.
  }
}

export default {
  watch: {
    rowView: function (value, previous) {
      if (value !== previous) persistArtworkRowView(value)
      if (previous === 'netx_images' && value !== 'netx_images') {
        this.resetNetxReview()
      }
    },
    search: function (val) {
      this.$emit('saveSearchValue', val || '')
    },
    p: function (val) {
      // this.$emit('saveArtworkPageValue', val || '')
      if (val.page > 0) {
        this.$store.dispatch('setPageNumber', {
          string: this.p.page,
          section: 'artworks',
        })
      }
    },
  },
  data() {
    return {
      facetSelections: {
        acquisition: [],
        text_completeness: [],
      },
      rowView: savedArtworkRowView(),
      textDrawerOpen: false,
      textDrawerArtwork: null,
      textDrawerText: null,
      netxReviewAssetsByArtwork: {},
      netxReviewStates: {},
      netxReviewQueue: [],
      netxReviewBatchTimer: null,
      netxReviewPollingTimer: null,
      netxReviewSyncTimer: null,
      netxReviewSyncActiveArtworkId: null,
      netxReviewGeneration: 0,
      netxReviewPollFailures: 0,
      selectedTags: [],
      show_change_location_dialog: false,
      show_attach_tag_dialog: false,
      and: false,
      showSelection: false,
      constants: constants,
      showFilter: false,
      hasSaved: false,
      selected_filter_tags: [],
      fields: fields,
      ownerships: [],
      selectedOwnership: 'all',
      searchAll: false,
      append_notes: true,
      append_credit: true,
      locations: [],
      panel: [],
      menu2: false,
      artwork_location_log: {
        storage: '',
        note: '',
        change_date: '',
        artwork_location_id: '',
        copy: '',
      },
      commissions: 'all',
      properties: [
        'location_notes',
        'credit',
        'type_of_work_id',
        'visa_status',
        // "selections",
      ],
      propertyToUpdate: 'location',
      propertyValue: '',
      showTags: false,
      save_tag_form_display: false,
      tag_title: '',
      selected_g: [],
      sort: 'title',
      subsort: 'accession_number',
      showSearch: this.$store.state.showSearch,
      view: this.$store.state.view,
      list_view: true,
      drawer2: null,
      options: this.$store.state.options,
      list: null,
      p: {
        sortBy: 'sort_name',
        page: this.$store.state.pageNumbers['artworks'],
      },
      // fields: ["artwork_location_id", "type_of_work"],
      dialog: false,
      batchDialog: false,
      edited_artwork: {
        type_of_work_id: '',
        location_notes: '',
        credit: '',
        visa_status: '',
      },
      show_tag_filter: false,
      show_classifications: false,
      filter: {
        selected_classifications: [],
        selected_classification_negations: [],
      },
      ta: [],
      selected_tags_assign: [],
      selected_tags: [],
      selected_tag_categories: [],
      selected: [],
      search: '',
      searchTags: '',
      headers: [
        { sortable: false },
        { value: 'id', sortable: false },
        { text: 'Artist', value: 'name', align: 'center' },
        { text: '', value: 'full_name', align: 'center' },
        { text: '', value: 'sort_name', align: 'center' },
        { text: '', value: 'location_name', align: 'center' },
        { text: '', value: 'title', align: 'center' },
        { text: 'Accession No.', value: 'accession_number_for_sorting', align: 'center' },
        { text: 'Accession No.', value: 'accession_number', hidden: true },
        // { text: 'Classification', value: 'classification', align: 'center' },
        { text: 'Freeport', value: 'visa_status', align: 'center' },
        {
          text: 'Todos',
          value: 'artwork_todos.filter(at => at.done != 1)',
          align: 'center',
        },
        // { text: 'Tags', value: 'tags', sortable: false }
      ],
      prevHeight: 0,
    }
  },
  props: ['items'],
  methods: {
    topPhotoUrl(artwork, size = 'big') {
      const middle = size === 'middle'
      return artworkImageUrl(
        artwork,
        middle ? ['cms_middle', 'cms_big', 'cms_thumbnail'] : ['cms_big', 'cms_middle', 'cms_thumbnail'],
        this.$globals.apiserver,
        this.$globals.fileserver,
        middle ? 'th_middle' : 'th_big'
      )
    },
    hasArtworkSeries(artwork) {
      return artwork && Array.isArray(artwork.artwork_series) && artwork.artwork_series.length > 0
    },
    artworkSeriesLabel(artwork) {
      if (!this.hasArtworkSeries(artwork)) return ''
      const names = artwork.artwork_series
        .map(series => series.title || series.title_en || series.title_es || 'Untitled series')
        .join(', ')
      return `Part of artwork series: ${names}`
    },
    hasCurrentExhibitions(artwork) {
      return artwork && Array.isArray(artwork.current_exhibitions) && artwork.current_exhibitions.length > 0
    },
    currentExhibitionsLabel(artwork) {
      if (!this.hasCurrentExhibitions(artwork)) return ''
      const names = artwork.current_exhibitions
        .map(exhibition => exhibition.title || exhibition.name || 'Untitled exhibition')
        .join(', ')
      return `Currently on view: ${names}`
    },
    openAddText(artwork) {
      this.textDrawerArtwork = artwork
      this.textDrawerText = null
      this.textDrawerOpen = true
    },
    openEditText({ artwork, text }) {
      this.textDrawerArtwork = artwork
      this.textDrawerText = text
      this.textDrawerOpen = true
    },
    onTextSaved({ artworkId, summary }) {
      this.$store.commit('UPSERT_ARTWORK_TEXT_SUMMARY', {
        artwork_id: artworkId,
        summary,
      })
    },
    onRepresentativeSaved({ artworkId, representativeTextId }) {
      this.$store.commit('UPDATE_ARTWORK_REPRESENTATIVE_TEXT', {
        artwork_id: artworkId,
        representative_text_id: representativeTextId,
      })
    },
    netxReviewAssetsFor(artworkId) {
      return this.netxReviewAssetsByArtwork[artworkId] || []
    },
    netxReviewLoadingFor(artworkId) {
      const state = this.netxReviewStates[artworkId]
      return !!(state && state.loading)
    },
    netxReviewErrorFor(artworkId) {
      const state = this.netxReviewStates[artworkId]
      return (state && state.error) || ''
    },
    netxReviewSyncFor(artworkId) {
      const state = this.netxReviewStates[artworkId]
      return (state && state.sync) || {}
    },
    netxReviewSyncDisabledFor(artworkId) {
      return this.netxReviewSyncActiveArtworkId !== null &&
        String(this.netxReviewSyncActiveArtworkId) !== String(artworkId)
    },
    setNetxReviewSyncState(artworkId, sync) {
      const state = this.netxReviewStates[artworkId] || {}
      this.$set(this.netxReviewStates, artworkId, Object.assign({}, state, { sync }))
    },
    setNetxReviewNotice(artworkId, error) {
      const state = this.netxReviewStates[artworkId] || {}
      this.$set(this.netxReviewStates, artworkId, Object.assign({}, state, { error }))
    },
    ensureNetxReviewArtwork({ artworkId, retry }) {
      if (this.rowView !== 'netx_images' || !artworkId) return
      const state = this.netxReviewStates[artworkId] || {}
      if (!retry && (state.loading || state.loaded)) return

      this.$set(this.netxReviewStates, artworkId, Object.assign({}, state, {
        loading: true,
        loaded: false,
        error: '',
      }))
      if (!this.netxReviewQueue.includes(artworkId)) this.netxReviewQueue.push(artworkId)
      window.clearTimeout(this.netxReviewBatchTimer)
      this.netxReviewBatchTimer = window.setTimeout(() => this.flushNetxReviewQueue(), 0)
    },
    async flushNetxReviewQueue() {
      const artworkIds = this.netxReviewQueue.splice(0)
      if (artworkIds.length === 0 || this.rowView !== 'netx_images') return
      const generation = this.netxReviewGeneration

      try {
        const assets = await loadNetxAssets({ artwork_ids: artworkIds })
        if (generation !== this.netxReviewGeneration || this.rowView !== 'netx_images') return
        this.replaceNetxReviewArtworkAssets(artworkIds, assets)
        this.scheduleNetxReviewPolling()
      } catch (error) {
        if (generation !== this.netxReviewGeneration) return
        artworkIds.forEach(artworkId => {
          const state = this.netxReviewStates[artworkId] || {}
          this.$set(this.netxReviewStates, artworkId, Object.assign({}, state, {
            loading: false,
            loaded: false,
            error: 'NetX images could not be loaded.',
          }))
        })
      }
    },
    replaceNetxReviewArtworkAssets(artworkIds, assets) {
      const grouped = {}
      artworkIds.forEach(artworkId => { grouped[artworkId] = [] })
      assets.forEach(asset => {
        if (!grouped[asset.artwork_id]) grouped[asset.artwork_id] = []
        grouped[asset.artwork_id].push(asset)
      })
      artworkIds.forEach(artworkId => {
        const state = this.netxReviewStates[artworkId] || {}
        this.$set(this.netxReviewAssetsByArtwork, artworkId, grouped[artworkId] || [])
        this.$set(this.netxReviewStates, artworkId, Object.assign({}, state, {
          loading: false,
          loaded: true,
          error: '',
        }))
      })
    },
    setNetxReviewSelection({ asset, desired }) {
      const artworkId = asset.artwork_id
      if (!artworkId || this.netxArtworkSelectionBusy(artworkId) || !asset.promotable) return
      this.$set(asset, 'selection', pendingSelection(asset, desired))

      updateNetxSelection(artworkId, asset.id, desired).then(response => {
        this.$set(asset, 'selection', response.data)
        this.netxReviewPollFailures = 0
        this.scheduleNetxReviewPolling()
      }).catch(error => {
        const message = selectionError(error)
        this.$set(asset, 'selection', failedSelection(asset, message))
      })
    },
    async syncNetxReviewArtwork({ artworkId }) {
      if (this.netxReviewSyncActiveArtworkId !== null) return
      this.netxReviewSyncActiveArtworkId = artworkId
      this.setNetxReviewSyncState(artworkId, { status: 'pending', pollFailures: 0 })

      try {
        const response = await startNetxArtworkImport(artworkId)
        this.setNetxReviewSyncState(artworkId, Object.assign({}, response.data, { pollFailures: 0 }))
        this.scheduleNetxReviewSyncPolling(artworkId, response.data.id)
      } catch (error) {
        this.netxReviewSyncActiveArtworkId = null
        this.setNetxReviewSyncState(artworkId, {
          status: 'failed',
          error_message: artworkImportError(error),
        })
      }
    },
    scheduleNetxReviewSyncPolling(artworkId, importRunId, delay) {
      window.clearTimeout(this.netxReviewSyncTimer)
      if (this.rowView !== 'netx_images') return
      this.netxReviewSyncTimer = window.setTimeout(
        () => this.pollNetxReviewSync(artworkId, importRunId),
        delay || 1200
      )
    },
    async pollNetxReviewSync(artworkId, importRunId) {
      const generation = this.netxReviewGeneration
      const previous = this.netxReviewSyncFor(artworkId)

      try {
        const response = await loadNetxImportRun(importRunId)
        if (generation !== this.netxReviewGeneration || this.rowView !== 'netx_images') return
        const sync = Object.assign({}, response.data, { pollFailures: 0 })
        this.setNetxReviewSyncState(artworkId, sync)
        if (['pending', 'running'].includes(sync.status)) {
          this.scheduleNetxReviewSyncPolling(artworkId, importRunId)
          return
        }

        this.netxReviewSyncActiveArtworkId = null
        if (sync.status === 'completed') {
          await this.reloadNetxReviewArtworks([artworkId], generation)
          this.scheduleNetxReviewPolling()
        }
      } catch (error) {
        if (generation !== this.netxReviewGeneration) return
        const pollFailures = (previous.pollFailures || 0) + 1
        if (pollFailures < 3) {
          this.setNetxReviewSyncState(artworkId, Object.assign({}, previous, { pollFailures }))
          this.scheduleNetxReviewSyncPolling(artworkId, importRunId, 2200)
          return
        }
        this.netxReviewSyncActiveArtworkId = null
        this.setNetxReviewSyncState(artworkId, {
          status: 'failed',
          error_message: 'NetX sync status could not be refreshed.',
        })
      }
    },
    netxArtworkSelectionBusy(artworkId) {
      return this.netxReviewAssetsFor(artworkId).some(asset =>
        (asset.selection && asset.selection.active) || mediaActive(asset)
      )
    },
    activeNetxReviewAssets() {
      return Object.keys(this.netxReviewAssetsByArtwork).reduce((active, artworkId) => {
        return active.concat(this.netxReviewAssetsByArtwork[artworkId].filter(asset =>
          (asset.selection && asset.selection.active) || mediaActive(asset)
        ))
      }, [])
    },
    scheduleNetxReviewPolling(delay) {
      window.clearTimeout(this.netxReviewPollingTimer)
      if (this.rowView !== 'netx_images' || this.activeNetxReviewAssets().length === 0) return
      this.netxReviewPollingTimer = window.setTimeout(
        () => this.pollNetxReviewAssets(),
        delay || 1500
      )
    },
    async pollNetxReviewAssets() {
      const activeAssets = this.activeNetxReviewAssets()
      if (activeAssets.length === 0 || this.rowView !== 'netx_images') return
      const generation = this.netxReviewGeneration

      try {
        const refreshed = await loadNetxAssets({ ids: activeAssets.map(asset => asset.id) })
        if (generation !== this.netxReviewGeneration || this.rowView !== 'netx_images') return
        this.netxReviewPollFailures = 0
        const terminalArtworkIds = []
        refreshed.forEach(asset => {
          const originalArtworkId = this.mergeNetxReviewAsset(asset)
          if ((!asset.selection || !asset.selection.active) && !mediaActive(asset)) {
            terminalArtworkIds.push(originalArtworkId || asset.artwork_id)
          }
        })
        const refreshedIds = refreshed.map(asset => asset.id)
        activeAssets.filter(asset => !refreshedIds.includes(asset.id)).forEach(asset => {
          this.$set(asset, 'selection', failedSelection(asset, 'This NetX asset is no longer available.'))
          terminalArtworkIds.push(asset.artwork_id)
        })
        if (terminalArtworkIds.length > 0) {
          await this.reloadNetxReviewArtworks([...new Set(terminalArtworkIds)], generation)
        }
        this.scheduleNetxReviewPolling()
      } catch (error) {
        if (generation !== this.netxReviewGeneration) return
        this.netxReviewPollFailures += 1
        if (this.netxReviewPollFailures < 3) {
          this.scheduleNetxReviewPolling(2500)
          return
        }
        activeAssets.forEach(asset => {
          const artworkId = asset.artwork_id
          const state = this.netxReviewStates[artworkId] || {}
          this.$set(this.netxReviewStates, artworkId, Object.assign({}, state, {
            error: 'NetX update status could not be refreshed. Retry this artwork.',
          }))
        })
      }
    },
    mergeNetxReviewAsset(refreshed) {
      const artworkIds = Object.keys(this.netxReviewAssetsByArtwork)
      for (let index = 0; index < artworkIds.length; index += 1) {
        const artworkId = artworkIds[index]
        const assets = this.netxReviewAssetsFor(artworkId)
        const assetIndex = assets.findIndex(asset => asset.id === refreshed.id)
        if (assetIndex === -1) continue

        if (String(refreshed.artwork_id) === String(artworkId)) {
          this.$set(assets, assetIndex, refreshed)
        } else {
          assets.splice(assetIndex, 1)
          const state = this.netxReviewStates[artworkId] || {}
          this.$set(this.netxReviewStates, artworkId, Object.assign({}, state, {
            error: 'A NetX asset was reassigned after its accession number changed.',
          }))
        }
        return Number(artworkId)
      }
      return null
    },
    async reloadNetxReviewArtworks(artworkIds, generation) {
      const assets = await loadNetxAssets({ artwork_ids: artworkIds })
      if (generation !== this.netxReviewGeneration || this.rowView !== 'netx_images') return
      this.replaceNetxReviewArtworkAssets(artworkIds, assets)
    },
    resetNetxReview() {
      window.clearTimeout(this.netxReviewBatchTimer)
      window.clearTimeout(this.netxReviewPollingTimer)
      window.clearTimeout(this.netxReviewSyncTimer)
      this.netxReviewGeneration += 1
      this.netxReviewPollFailures = 0
      this.netxReviewQueue = []
      this.netxReviewSyncActiveArtworkId = null
      this.netxReviewAssetsByArtwork = {}
      this.netxReviewStates = {}
    },
    exportToExcel() {
      // Prepare data for export
      const data = this.table_artworks.map(artwork => ({
        'Artist': artwork.name,
        'Full Name': artwork.full_name,
        // 'Sort Name': artwork.sort_name,
        // 'Location': artwork.location_name,
        'Title': artwork.title,
        'Accession No.': artwork.accession_number,
        'Todos': artwork.artwork_todos.filter(at => at.done != 1).length,
        'Created': artwork.created_at,
        'Updated': artwork.updated_at,
        'Deaccessioned': artwork.deaccessioned == 1 ? 'Yes' : 'No',
        'Deaccession Date': artwork.deaccession_date,
        // 'Acquisition Source': artwork.acquisition_source_id ? this.$store.state.acquisition_sources.find(a => a.id == artwork.acquisition_source_id).name : 'Unknown',
        // 'Acquisition Method': artwork.acquisition_method ? this.$store.state.acquisition_methods.find(a => a.id == artwork.acquisition_method).name : 'Unknown',
        // 'Acquisition Method Text': artwork.acquisition_method_text,
        // 'Purchase Price': artwork.purchased_price,
        // 'Purchase Price Currency': artwork.purchased_price_currency,
        // 'Insurance Value': artwork.insurance_value,
        // 'Insurance Value Currency': artwork.insurance_value_currency,
        'Credit': artwork.credit,
        'Tags': artwork.tags ? artwork.tags.map(t => '[' + t.name + ']').join(', ') : '',
        'Type of Work': artwork.type_of_work_id ? this.constants.TYPES_OF_WORK.find(t => t.id == artwork.type_of_work_id).name : 'Unknown',
        'Production Date': artwork.production_date_new,
        'Visa Status': artwork.visa_status ? this.constants.VISA_STATUSES.find(v => v.id == artwork.visa_status).name : 'Unknown',
      }))

      // Create worksheet
      const ws = XLSX.utils.json_to_sheet(data)
      
      // Create workbook
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws, 'Artworks')
      
      // Generate Excel file
      XLSX.writeFile(wb, `artworks_${new Date().toISOString().split('T')[0]}.xlsx`)
    },
    /**
     * Custom tag filter function to filter items based on query text and item text.
     *
     * @param {any} item - The item to be filtered.
     * @param {string} queryText - The query text used for filtering.
     * @param {string} itemText - The text of the item to be filtered.
     * @return {boolean} True if the item passes the filter, false otherwise.
     */
    customTagFilter(item, queryText, itemText) {
      
      // console.log('customTagFilter' + item.label + queryText + typeof(itemText));
      const sanitizeText = (text) => {
        return text
          .toString()
          .toLowerCase()
          // .replace(/\s+/g, '-')
          // .replace(/[^\w-]+/g, '')
          // .replace(/--+/g, '-')
          // .replace(/^-+/, '')
          // .replace(/-+$/, '');
      }
    
      const textOne = sanitizeText(item.label);
      const textTwo = sanitizeText(itemText);
      const searchText = sanitizeText(queryText);
    
      const setOfSearchStrings = searchText.split(' ');
    
      return setOfSearchStrings.every(searchString => 
        textOne.includes(searchString)
      );
    },
    toggleShowAttachTagDialog() {
      console.log('this.show_attach_tag_dialog')
      console.log(this.show_attach_tag_dialog)
      this.show_attach_tag_dialog = !this.show_attach_tag_dialog
    },

    // findTagName(tag) {
    //   const a = this.$store.state.tags.find(i => i.id === tag)
    //   if (a) {
    //     return a.name
    //   } else {
    //     return ''
    //   }
    // },
    // findTagExists(tag) {
    //   // console.log(tag)
    //   const a = this.$store.state.tags.find(i => i.id == tag)
    //   // console.log(a)
    //   return a
    // },
    remove (item) {
      console.log('remove' + item)
      console.log(this.selectedTags)
        const index = this.selectedTags.indexOf(item)
        if (index >= 0) this.selectedTags.splice(index, 1)
      },
    toggleSelection() {
      this.selected = Object.assign(
        [],
        this.ids2o(this.$store.state.currentSelection)
      )
      this.showSelection = !this.showSelection
    },
    updateFilterTags(tags) {
      console.log('updateFilterTags')
      console.log(tags)
      this.selectedTags = tags
      this.selected_filter_tags = tags
    },
    customFilter(item, queryText, itemText) {
      const textOne = item.name
        .toLowerCase()
        .replace(/ /g, '_')
        .replace('...', '')
        .replace(/ /g, '_')
        .replace(/\//g, '_')
        .replace(/\(\//g, '_')
      const textTwo = item.category
        ? textOne +
        '_' +
        item.category
          .toLowerCase()
          .replace(/ /g, '_')
          .replace('...', '')
          .replace(/\//g, '_')
        : textOne
      const searchText = queryText.toLowerCase()
      // var setOfSearchStrings = queryText.split(' ');

      // for(var i = 0; i < setOfSearchStrings.length; i++){
      //   if(mainString.indexOf(setOfSearchStrings[i]) != -1)
      //       stringExists = true;
      // }
      // let re = new RegExp('^(?=.*\\b' + textOne + '\\b)(?=.*\\b' + textTwo + '\\b).*$')
      // var rer = re.exec(queryText)
      // return rer
      return (
        textOne.indexOf(searchText) > -1 || textTwo.indexOf(searchText) > -1
      )
    },
    save() {
      this.isEditing = !this.isEditing
      this.hasSaved = true
    },
    toggleOwnership(o) {
      this.selectedOwnership = o
      // console.log('this.selectedOwnership')
      // console.log(this.selectedOwnership)
      // this.$store.dispatch('setFilter', { section: 'deaccession', ownership: o.id })
      // if (o.id !== 'all') {
      //   console.log('toggle - ownership not all')
      //   this.filtered = this.items.filter(a =>
      //      a.ownership == o.id
      //   )
      // } else {
      //   console.log('toggle - ownership is all')
      // this.filtered = this.items
      // }
    },
    setSearchValue() {
      this.search = this.$store.state.searchString['artworks']
    },
    setPageNumberValue() {
      this.p.page = this.$store.state.pageNumbers['artworks']
      // console.log(this.p.page)
    },
    searchAllToggle() {
      // console.log('searchAllToggle')
      // console.log(a)
      if (this.searchAll) {
        serverBus.$emit('setTitle', '')
        this.$emit('switchOwnershipTop')
        this.searchAll = false
      } else {
        serverBus.$emit('setTitle', 'Searching All Artworks')
        this.$emit('switchOwnershipToAll')
        this.searchAll = true
      }
    },
    imageUrlAlt(event) {
      event.target.src = '/static/no_image.jpg'
    },
    // modifyArtworks() {
    //   var props = this.properties.filter(
    //     (p) => this.edited_artwork[p] != null && this.edited_artwork[p] != ""
    //   );
    //   console.log(props);
    //   props.forEach((c) => {
    //     console.log(c);
    //     this.updateArtworks(c);
    //   });
    //   this.dialog = false;
    //   // this.contact = "";
    //   // this.artworks = [];
    //   // this.artworks2 = [];
    //   // this.selected = [];
    //   this.dialog = false;
    // },
    updateArtworks() {
      var ea = Object.entries(this.edited_artwork).reduce(
        (a, [k, v]) => (v ? ((a[k] = v), a) : a),
        {}
      )
      ;[
        'artwork_location_id',
        'master_physical_location_id',
        'archive_master_location_id',
        'access_copy_location_id',
        'artwork_location_copy_id',
        'location_id',
      ].forEach(field => delete ea[field])
      this.selected.forEach((c) => {
        // this.edited_artwork.id = c.id;
        // console.log(c.credit);
        // console.log(this.edited_artwork.credit);
        if (c.credit) {
          ea.credit = `${c.credit}\n${ea.credit}`
        }
        if (c.location_notes) {
          ea.location_notes = `${c.location_notes}\n${ea.location_notes}`
        }
        // console.log(ea.credit);
        this.$emit('showSnackbar', 'Updating Artwork: ' + c.title)
        setTimeout(() => {
          let url = `${this.$globals.apiserver}/artworks/${c.id}.json`
          // let url = `http://localhost:8080/artworks/${c.id}.json`;
          // console.log("updating artwork start");
          // console.log(url);
          // // console.log(property);
          // console.log(this.edited_artwork);
          // console.log(ea);
          // console.log(c);
          // console.log("updating artwork end");
          axios
            .put(url, {
              artwork: ea,
              // field_value: this.propertyValue,
              updated_by: this.c_user.id,
            })
            .then((response) => {
              this.$emit('showSnackbar', "Saved Artwork's ", 'green')
              this.progress = false
              this.isEditing = false
              this.$store.dispatch('loadArtworks')
              this.dialog = false
              this.edited_artwork = {
                type_of_work_id: '',
                location_notes: '',
                credit: '',
                visa_status: '',
              }
            })
            .catch((error) => {
              // console.log(error)
              this.$emit('showSnackbar', 'Error Saving Artwork ', 'red')
              this.progress = false
              this.isEditing = false
            })
        }, 1000)
      })
      // this.batchDialog = false;
      // this.contact = "";
      // this.artworks = [];
      // this.artworks2 = [];
      // this.selected = [];
    },
    resetSelected() {
      this.selected = []
      // this.artworks = [];
      // this.artworks2 = [];
    },
    showBatchUpdateDialog() {
      // this.batchDialog = true;
      this.dialog = true
      // this.artworks = this.$store.state.artworks.filter(a =>
      //   this.selected.map(a => a.id).includes(a.acquisition_source_id)
      // );
    },
    // showAttachTagDialog() {
      // this.batchDialog = true;
      // this.show_attach_tag_dialog = true
      // this.artworks = this.$store.state.artworks.filter(a =>
      //   this.selected.map(a => a.id).includes(a.acquisition_source_id)
      // );
    // },
    goToUrl(url) {
      window.open(url, '_blank')
    },
    // getFiltered(e){
    //   // console.log(e) //output the filtered items
    // },
    close_save_tag_form() {
      // console.log(this.save_tag_form_display)
      this.save_tag_form_display = false
      // console.log(this.save_tag_form_display)
      this.tag_title = ''
    },
    create_tag() {
      let url = `${this.$globals.apiserver}/tags.json`
      axios
        .post(url, { tag: { name: this.tag_title } })
        .then((response) => {
          this.$store.dispatch('loadTags')
          this.save_tag_form_display = false
          this.tag_title = ''
          this.$router.push({
            name: 'EditArtist',
            // path: `/artists/edit/${this.artist.id}`,
            params: { id: this.artist.id, artist: this.artist },
          })
        })
        .catch((error) => {
          // console.log(error)
        })
    },
    assignTagsToMultipleArtworks(tagIds) {
      this.$emit('showSnackbar', 'Assigning tags to selected artworks...')
      let artworks = this.selected.map((a) => a.id)
      axios
        .post(`${this.$globals.apiserver}/artworks/assign_tags`, {
          artwork_ids: artworks, // array of artwork IDs
          tag_ids: this.selected_tags_assign             // array of tag IDs to assign
        })
        .then(response => {
          this.$emit('showSnackbar', 'Tags assigned to selected artworks.', 'green')
          this.$store.dispatch('loadArtworks')
          this.$emit('switchOwnershipTop')
          this.errors = {}
          this.selected_tags_assign = []
        })
        .catch(error => {
          this.errors = error.response.data
          serverBus.$emit('showSnackbar', 'Error saving tags to artworks.', 'red')
        })
    },
    // assignTagsToArtworks() {
    //   serverBus.$emit('showSnackbar', 'Saving Tags to Artworks…')
    //   let url = `${this.$globals.apiserver}/artworks/2.json`
    //   let artworks = this.selected.map((a) => a.id)
    //   axios
    //     .put(url, {
    //       artworks: artworks,
    //       tags: this.selected_tags_assign,
    //       save_tags_to_artworks: 1,
    //     })
    //     .then((response) => {
    //       this.$store.dispatch('loadArtworks')
    //       this.$emit('switchOwnershipTop')
    //       this.errors = {}
    //       this.selected_tags_assign = []
    //       // for (var i in artworks) {
    //       //   if (artworks[i].value === value) {
    //       //     artworks[i].desc = desc
    //       //     break // Stop this loop, we found it!
    //       //   }
    //       // }
    //       // response.data.artworks
    //       // this.artwork.tags = response.data;
    //       serverBus.$emit('showSnackbar', 'Tags saved.', 'green')
    //       // this.$store.commit('ADD_COST', response.data)
    //     })
    //     .catch((error) => {
    //       // console.log(error)
    //       // this.errors = error.response.data;
    //     })
    //   // this.tag = {
    //   //   description: '',
    //   //   title: ''
    //   // }
    // },
    // refresh_list () {
    //   // console.log (this.table_artworks[0])
    //   return this.table_artworks
    //   // console.log (this.table_artworks[0])
    // },
    closeOptions() {
      this.options = !this.options
      this.$store.dispatch('saveOptions', !this.$store.state.options)
    },
    all_todos(artwork) {
      let todos
      if (artwork.artwork_todos && artwork.artwork_todos.length > 0) {
        todos = Object.assign([], artwork.artwork_todos)
      } else {
        todos = []
      }
      var fields = [
        { id: 'credit', f: 'credit', m: 'Missing Credit' },
        { id: 'signature_new', f: 'signature_new', m: 'Missing Signature' },
        {
          id: 'acquisition_date',
          f: 'acquisition_date',
          m: 'Missing Acquisition Date',
        },
        {
          id: 'specs_on_space',
          f: 'specs_on_space',
          m: 'Missing Info on Space',
        },
        { id: 'technician', f: 'technician', m: 'Missing Technician' },
        {
          id: 'installation_time',
          f: 'installation_time',
          m: 'Days of Installation',
        },
      ]
      for (let f of fields) {
        if (artwork[f.f] == null || artwork[f.f] === '') {
          todos.push({ id: f.id, title: f.m, done: false, completed: false })
        }
      }
      return todos
    },
    get_type_of_work(id) {
      return this.constants.TYPES_OF_WORK.find((tow) => tow.id === id).name
      // if (vss[0] != undefined) {
      //   return vss[0].id > 0 ? vss[0].name : ""
      // } else {
      //   return ""
      // }
    },
    // get_visa_status(artwork) {
    //   var vss = this.constants.VISA_STATUSES.filter(
    //     vs => vs.id === artwork.visa_status
    //   );
    //   if (vss[0] != undefined) {
    //     // console.log(vss[0].id)
    //     return vss[0].id > 0 ? vss[0].name : "";
    //   } else {
    //     return "";
    //   }
    // },
    // get_location_name(id) {
    //   var l = this.$store.state.locations.find(l => l.id === id);
    //   return l ? l.name : "";
    // },
    addField() { },
    switchSwitch() {
      this.show_tag_filter = !this.show_tag_filter
      this.$emit('switchOwnershipTop', this.show_tag_filter)
    },
    clearFilters() {
      this.selected_tags = []
      this.selected_tag_categories = []
    },
    clear_selection() {
      this.$store.dispatch('clearCurrentSelection')
      this.selected = []
    },
    addSelectedToSelection() { },
    addAllToSelection() {
      // this.selected = this.items
      // console.log(this.table_artworks)
      // console.log(this.selected)
      var tempSelection = Object.assign([], this.$store.state.currentSelection)
      // console.log(tempSelection)
      // tempSelection = tempSelection.map(a => a.id)
      // console.log(tempSelection)
      this.table_artworks.forEach((a) => {
        // if (!a) {
        if (!tempSelection.includes(a.id)) {
          tempSelection.push(a.id)
        }
        // } else {
        //   // console.log('false')
        //   var index = tempSelection.indexOf(b);
        //   // console.log('index = ' + index)
        //   tempSelection.splice(index,1)
        // }
      })
      // this.$store.state.currentSelection
      // console.log(tempSelection)
      // this.selected.forEach(s => {
      //   if (!tempSelection.includes(s)) {
      //     tempSelection.push(s)
      //   }
      // })
      // this.$store.dispatch('saveCurrentSelection',this.$store.state.currentSelection.concat(this.selected).filter((el, i, a) => i === a.indexOf(el)))
      this.$store.dispatch('saveCurrentSelection', tempSelection)
      // console.log(tempSelection)
    },
    addFilteredToSelection() {
      if (!this.$refs.dTable) return

      let p = this.p.rowsPerPage
      // console.log(this.$refs['dTable'].filteredItems)
      this.p.rowsPerPage = 100000
      // console.log(this.$refs['dTable'].filteredItems)
      // this.selected = this.items
      // let items = this.$refs. dTable.$children[0].filteredItems;
      // let sortBy = this.$refs. dTable.$children[0].options.sortBy;
      // let sortDesc = this.$refs. dTable.$children[0].options.sortDesc;
      // let sorted = this.$refs. dTable.customSortWithHeaders(items, sortBy, sortDesc);
      // console.log(this.$refs.dTable.$children[0])
      // console.log(this.$refs.dTable.$children[0].filteredItems)
      // console.log(this.$refs.dTable.$children[0].options.sortDesc)
      // console.log(this.$refs.dTable.filteredItems)
      var tempSelection = Object.assign([], this.$store.state.currentSelection)
      // console.log(tempSelection)
      // tempSelection = tempSelection.map(a => a.id)
      // console.log(tempSelection)
      this.$refs.dTable.filteredItems.forEach((a) => {
        // if (!a) {
        if (!tempSelection.includes(a.id)) {
          tempSelection.push(a.id)
        }
        // } else {
        //   // console.log('false')
        //   var index = tempSelection.indexOf(b);
        //   // console.log('index = ' + index)
        //   tempSelection.splice(index,1)
        // }
      })
      this.p.rowsPerPage = p
      // this.$store.state.currentSelection
      // console.log(tempSelection)
      // this.selected.forEach(s => {
      //   if (!tempSelection.includes(s)) {
      //     tempSelection.push(s)
      //   }
      // })
      // this.$store.dispatch('saveCurrentSelection',this.$store.state.currentSelection.concat(this.selected).filter((el, i, a) => i === a.indexOf(el)))
      this.$store.dispatch('saveCurrentSelection', tempSelection)
      // console.log(tempSelection)
    },
    // save_selection () {
    //   this.$store.dispatch('clearCurrentSelection')
    // },
    // tags_for_artwork(tags) {
    //   var ar = []
    //   // console.log(tags)
    //   tags.forEach(tag => {
    //     ar.push(this.$store.state.tags.filter(i => i.id === tag.id)[0].name)
    //   })
    //   // console.log(ar)
    //   return ar.join(', ')
    // },
    save_currently_selected(a, b) {
      // console.log('///////////')
      // console.log('a = ' + a)
      // console.log('b.id = ' + b.id)
      // console.log(this.selected)
      // console.log(this.selected)
      // console.log(this.$store.state.currentSelection)
      // setTimeout(function () {
      var tempSelection = Object.assign([], this.$store.state.currentSelection)
      // tempSelection = tempSelection.map(a => a.id)
      if (!a) {
        if (!tempSelection.includes(b.id)) {
          tempSelection.push(b.id)
        }
      } else {
        const index = tempSelection.indexOf(b.id)
        tempSelection.splice(index, 1)
      }
      // this.$store.state.currentSelection
      // console.log(tempSelection)
      // this.selected.forEach(s => {
      //   if (!tempSelection.includes(s)) {
      //     tempSelection.push(s)
      //   }
      // })
      // this.$store.dispatch('saveCurrentSelection',this.$store.state.currentSelection.concat(this.selected).filter((el, i, a) => i === a.indexOf(el)))
      this.$store.dispatch('saveCurrentSelection', tempSelection)
      // this.$store.dispatch('saveCurrentSelection',this.selected_ids)
      // console.log(tempSelection)
      // }.bind(this),1000)
    },
    save_currently_selected_gallery(a, b) {
      // console.log('a = ' + a)
      // console.log('b = ' + b.id)
      // setTimeout(function () {
      var tempSelection = Object.assign([], this.$store.state.currentSelection)
      if (!a) {
        if (!tempSelection.includes(b)) {
          tempSelection.push(b.id)
        }
      } else {
        var index = tempSelection.indexOf(b.id)
        tempSelection.splice(index, 1)
      }
      this.$store.dispatch('saveCurrentSelection', tempSelection)
      // }.bind(this),1000)
    },
    // save_currently_selected_all (a) {
    //   // console.log('///////////')
    //   // console.log('a = ' + a)
    //   var tempSelection = Object.assign(
    //     [],
    //     this.$store.state.currentSelection
    //   )
    //   // console.log(tempSelection)
    //   if (!a) {
    //     // console.log('a true')
    //     if (!tempSelection.includes(b)) {
    //       // console.log('doesnt include')
    //       tempSelection.push(b)
    //     }
    //   } else {
    //     // console.log('false')
    //     var index = tempSelection.indexOf(b)
    //     // console.log('index = ' + index)
    //     tempSelection.splice(index, 1)
    //   }
    //   // this.$store.state.currentSelection
    //   // console.log(tempSelection)
    //   // this.selected.forEach(s => {
    //   //   if (!tempSelection.includes(s)) {
    //   //     tempSelection.push(s)
    //   //   }
    //   // })
    //   // this.$store.dispatch('saveCurrentSelection',this.$store.state.currentSelection.concat(this.selected).filter((el, i, a) => i === a.indexOf(el)))
    //   this.$store.dispatch('saveCurrentSelection', tempSelection)
    // },
    save_currently_selected_tags() {
      this.$store.dispatch('saveCurrentSelectionTags', this.selected_tags)
      this.ta = this.tagged_artworks
    },
    // assignTagsToArtworks() {
    //   // console.log('this.selected')
    //   // console.log(this.selected)
    //   // console.log(this.selected_tags_assign)
    // }

    // ANIMATIONS
    beforeLeave(element) {
      this.prevHeight = getComputedStyle(element).height
    },
    enter(element) {
      const { height } = getComputedStyle(element)

      element.style.height = this.prevHeight

      setTimeout(() => {
        element.style.height = height
      })
    },
    afterEnter(element) {
      element.style.height = 'auto'
    },
    // custom function for data-table to filter artworks by tag ids
    // returns true if the artwork has all the selected tags
    // customTableSearch(item, terms) {
    //   // console.log('customTableSearch')
    //   // console.log(terms)
    //   // console.log(item)
    //   return item.title.indeOf(terms)
    //   // return true
    // },
      
    
      
  },
  
  computed: {
    tags() {
      return this.$store.state.tags.filter((item) => item.category  == 'concept')
    },
    tagNames() {
      return this.$store.getters.formattedTags;
    },

    tag_items() {
      return this.fields.tabs['basic'].fields.filter((item) => !!item.tag)
    },
    // locationsSorted: state => {
    //   return this.locations.sort(dynamicSort('name'))
    // },
    // selected_ids () {
    //   return this.selected.map(a => a.id)
    // },
    options_c: {
      get() {
        return this.$store.state.options
      },
      set(value) {
        this.$store.dispatch('saveOptions', value)
      },
    },
    // artworks_selections() {
    // for (var b in this.$store.state.artworks_selections) {
    // console.log(this.$store.state.artworks_selections[b])
    // }
    //   return Object.assign([],this.$store.state.artworks_selections).reverse()
    // },
    currrent_path() {
      return this.$route.params.ownership
    },
    // saved_lists () {
    //   return [{id:1,title:'list1'}, {id:2,title:'list2'}]
    // },
    // selected_artworks () {
    //   return this.$store.state.currentSelection
    // },

    selectedOwnershipName() {
      switch (this.selectedOwnership) {
            case 'all_acquired':
              return 'All Acquired';
            case 'tba_commissions':
              return 'TBA Commissions';
            case 'tba_academy_commissions':
              return 'TBA Academy Commissions';
            case 'all_not_acquired_commissions':
              return 'All Not Acquired Commissions';
            case 'not_acquired_tba_commissions':
              return 'Not Acquired TBA Commissions';
            case 'not_acquired_academy_commissions':
              return 'Not Acquired Academy Commissions';
            default:
              return 'All';
        }
    },
    table_artworks() {
      console.log('ArtworksTable.table_artworks')
      if (this.showSelection) {
        return this.selected;
      }

      var filteredArtworks = [];
      // Filter by section
      if (this.$route.fullPath === '/artworks/ownership/deaccession') {
        filteredArtworks = this.items.filter((artwork) => artwork.deaccessioned === 1);
      } else if (this.$route.fullPath === '/artworks/ownership/commissions') {
        // Filter for commissions - `tba`, `com_academy`, or all commissions
        if (this.commissions === 'tba') {
          filteredArtworks = this.items.filter(
            (artwork) => artwork.acquisition_method === 3 && artwork.acquired === 'acquired'
          );
        } else if (this.commissions === 'com_academy') {
          filteredArtworks = this.items.filter(
            (artwork) => artwork.acquired === 'com_academy'
          );
        } else {
          filteredArtworks = this.items;
        }
      } else {
        filteredArtworks = this.items;
      }
      filteredArtworks = filterArtworksByFacets(filteredArtworks, this.facetSelections)

      // Filter by tags, if any OLD ! ! ! !
      // console.log('Filter by tags OLD')
      // console.log(this.selected_filter_tags)
      // if (this.selected_filter_tags.length > 0) {
      //   filteredArtworks = filteredArtworks.filter((artwork) =>
      //     artwork.tags.some((aTag) => this.selected_filter_tags.indexOf(aTag.id) > -1)
      //   );
      // }

      console.log('Filter by tags NEW')
      console.log(this.selectedTags.length)
      console.log(this.selectedTags)
      // console.log(this.selectedTags.indexOf('portrait'))
      if (this.selectedTags.length > 0) {
        filteredArtworks = filteredArtworks.filter((artwork) => {
          // console.log('eeeeeeeese', artwork.id)
          var out = artwork.tags.some((aTag) => {
            // console.log(aTag.name)
            return this.selectedTags.indexOf(aTag.id) > -1;
          })
          // console.log(out)
          return out
        }
        );
      }
      // if (this.selectedTags.length > 0) {
      //   filteredArtworks = filteredArtworks.filter((artwork) =>
      //     artwork.tags.some((aTag) => {
      //       const tagNames = [aTag.name, aTag.section];
      //       return tagNames.some((tagName) => this.selectedTags.includes(tagName));
      //     })
      //   );
      // }
      // if (this.selected_filter_tags.length > 0) {
      //   const andFilter = this.and;
      //   var filteredTags = [...this.selected_filter_tags];
      //   // Filter for concept tags
      //   this.$store.state.tags.filter((tag) => tag.concept_tag === 1).forEach((conceptTag) => {
      //     filteredTags = filteredTags.concat(
      //       this.$store.state.tags.filter((tag) => tag.category === conceptTag.name)
      //         .map((keywordTag) => keywordTag.id)
      //     );
      //   });

      //   // Apply tag filters
      //   if (andFilter) {
      //     filteredArtworks = filteredArtworks.filter((artwork) => {
      //       const artworkTagIds = artwork.tags.map((a) => a.id);
      //       const filteredTags = artworkTagIds.filter((value) =>
      //         filteredTags.includes(value)
      //       );
      //       return filteredTags.length === filteredTags.length;
      //     });
      //   } else {
      //     filteredArtworks = filteredArtworks.filter((artwork) => {
      //       return artwork.tags.some((aTag) => filteredTags.includes(aTag.id));
      //     });
      //   }
      // }


      return filteredArtworks;
    },

    // table_artworks() {
    //   // console.log('TABLE_ARTWORKS')
    //   // console.log(this.items)
    //   if (this.showSelection) {
    //     return this.selected
    //   }
    //   var filterTags = this.selected_filter_tags
    //   var afterSectionFilter = []
    //   var afterTagFilter = []
    //   var afterOwnershipFilter = []

    //   // filter for deaccessioned
    //   if (this.$route.fullPath === '/artworks/ownership/deaccession') {
    //     // console.log('toggle - deaccessioned')
    //     // console.log(this.selectedOwnership)

    //     afterSectionFilter = this.items.filter((a) => a.deaccessioned == 1)

    //     // filter for commissions
    //   } else if (
    //     this.$route.fullPath === '/artworks/ownership/commissions' &&
    //     this.commissions !== 'all'
    //   ) {
    //     // console.log("commissions - not all");

    //     if (this.commissions === 'not') {
    //       // console.log('not')
    //       afterSectionFilter = this.items.filter(
    //         (aa) => aa.acquired === 'commission'
    //       )
    //       // console.log(afterSectionFilter.length)
    //     } else if (this.commissions === 'tba') {
    //       // console.log('tba')
    //       afterSectionFilter = this.items.filter(
    //         (aa) => aa.acquisition_method === 3 && aa.acquired === 'acquired'
    //       )
    //     } else if (this.commissions === 'com_academy') {
    //       console.log('com_academy')
    //       console.log(this.items.length)
    //       afterSectionFilter = this.items.filter(
    //         (aa) => aa.acquired === 'com_academy'
    //       )
    //       console.log(afterSectionFilter.length)
    //     }

    //     // afterSectionFilter = this.items.filter(
    //     //   aa => aa.acquisition_method === (this.commissions === 'tba' ? 3 : 6)
    //     // )

    //     // else show all artworks
    //   } else {
    //     // console.log('toggle - not COMMISSION neither DEACCESSIONED')
    //     afterSectionFilter = this.items
    //   }

    //   // ak filtrujem by ownerships
    //   if (this.selectedOwnership.id !== 'all') {
    //     afterOwnershipFilter = afterSectionFilter.filter(
    //       (a) => a.ownership == this.selectedOwnership.id
    //     )
    //   } else {
    //     afterOwnershipFilter = afterSectionFilter
    //   }

    //   // ak filtrujem tagmi
    //   if (filterTags.length > 0) {
    //     // console.log('table_artworks - tags')
    //     this.and = filterTags.length === 1 ? (this.and = false) : this.and

    //     /// if there are any concept tags, i have to include all keyword tags in the filter
    //     /// i load all concept tags in var
    //     var conceptTags = []
    //     filterTags.forEach((ft) => {
    //       // console.log(ft)
    //       const found = this.$store.state.tags.find(
    //         (st) => st.id == ft && st.concept_tag == 1
    //       )
    //       if (found) {
    //         conceptTags.push(found)
    //       }
    //     })
    //     // console.log('conceptTags')
    //     // console.log(conceptTags)

    //     /// i search for related keyword tags and add them to temporary var array to filter by
    //     var outTags = Object.assign([], filterTags)
    //     conceptTags.forEach((ct) => {
    //       const keywordTags = this.$store.state.tags.filter(
    //         (st) => st.category == ct.name
    //       )
    //       // console.log('keywordTags')
    //       // console.log(keywordTags)
    //       const keywordTagsMapped = keywordTags.map((kt) => kt.id)
    //       outTags = outTags.concat(keywordTagsMapped)
    //     })
    //     // console.log(filterTags)
    //     // console.log('outTags')
    //     // console.log(outTags)

    //     if (this.and) {
    //       // console.log('AND')
    //       afterTagFilter = afterOwnershipFilter.filter((artwork) => {
    //         /// nacitam si idcka tagov artworku
    //         const artworkTagIds = artwork.tags.map((a) => a.id)
    //         // console.log('artworkTagIds')
    //         // console.log(artworkTagIds)
    //         // const filteringTagIds = filterTags.map(a => a.id)
    //         // console.log('filterTags')
    //         // console.log(filterTags)

    //         /// vyberiem z tagov artworku tie, ktore su vo filtri
    //         const filteredTags = artworkTagIds.filter((value) =>
    //           filterTags.includes(value)
    //         )
    //         // console.log(filteredTags)
    //         /// pocet tagov fo filtri a v artworku musi suhlasit aby bolo AND platne - toto funguje?
    //         const a = filteredTags.length === filterTags.length
    //         // overim, ci niektory z tagov artworku je vo vybranych tagoch
    //         // var a = artwork.tags.some(aTag => filterTags.indexOf(aTag.id) > -1)
    //         var b = a
    //         // if (
    //         //   this.$route.fullPath === '/artworks/ownership/commissions' &&
    //         //   this.commissions !== 'all'
    //         // ) {
    //         //   // console.log("tags - not all");
    //         //   b = a.filter(
    //         //     aa => aa.acquisition_method === (this.commissions === 'tba' ? 3 : 6)
    //         //   )
    //         // }
    //         // return Object.assign([],this.items).sort(dynamicSort(this.sort,this.subsort))
    //         return b
    //       })
    //     } else {
    //       // console.log('else')
    //       afterTagFilter = afterOwnershipFilter.filter((artwork) => {
    //         var a = artwork.tags.some((aTag) => outTags.indexOf(aTag.id) > -1)
    //         var b = a
    //         return b
    //       })
    //     }

    //     // no filters, return filtered after section filter
    //   } else {
    //     afterTagFilter = afterOwnershipFilter
    //   }
    //   return afterTagFilter
    //   // ak su tag filtre prazdne
    //   // }
    //   // else {
    //   //   console.log('no filters');
    //   //   var b = this.afterSectionFilter

    //   //   // if commissions
    //   //   if (
    //   //     this.$route.fullPath === '/artworks/ownership/commissions' &&
    //   //     this.commissions !== 'all'
    //   //   ) {
    //   //     // console.log('not all')
    //   //     // console.log(this.commissions)
    //   //     b = afterSectionFilter.filter(
    //   //       aa => aa.acquisition_method === (this.commissions === 'tba' ? 3 : 6)
    //   //     )
    //   //   // if route is DEACCESSIONED
    //   //   } else if (this.$route.fullPath === '/artworks/ownership/deaccession' && this.selectedOwnership.id !== 'all') {
    //   //     if (this.commissions === 'not') {
    //   //       // console.log('not')
    //   //       b = this.items.filter(
    //   //         aa => aa.acquired === 'commission'
    //   //       )
    //   //     } else if (this.commissions === 'tba') {
    //   //       // console.log('tba')
    //   //       b = this.items.filter(
    //   //         aa => aa.acquisition_method === 3 && aa.acquired === 'acquired'
    //   //       )
    //   //     }
    //   //     console.log(this.selectedOwnership.name)
    //   //   } else {
    //   //     b = afterSectionFilter
    //   //   }
    //   //   // return Object.assign([],this.items).sort(dynamicSort(this.sort,this.subsort))
    //   //   return b
    //   //   // $store.state.artworks
    //   // }
    // },
    tagged_artworks() {
      var cst = this.$store.state.currentSelectionTags
      return this.table_artworks.filter(function (artwork) {
        return artwork.tags.some((aTag) => cst.indexOf(aTag.id) > -1)
      })
    },
    select_tags() {
      var stc = this.selected_tag_categories
      var tc = this.$store.state.tag_categories
      var tags = Object.assign([], this.$store.state.tags)
      var out = []
      // add colors to tags from tag categories
      tags.forEach((tag) => {
        var a = tc.filter(function (tagc) {
          return tagc.id === tag.tag_category_id
        })
        if (a[0]) {
          tag.color = a[0].color
        }
        out.push(tag)
      })
      // console.log(out)
      return out.filter((tag) => stc.some((st) => tag.tag_category_id === st))
      // return out
    },
    select_tags_assign() {
      // var stc = this.selected_tag_categories
      var tc = this.$store.state.tag_categories
      var tags = Object.assign([], this.$store.state.tags)
      var out = []
      tags.forEach((tag) => {
        var a = tc.filter(function (tagc) {
          return tagc.id === tag.tag_category_id
        })
        if (a[0]) {
          tag.color = a[0].color
        }
        out.push(tag)
      })
      // return out.filter(function(tag) { return stc.some(st => tag.tag_category_id==st)})
      return out
    },
    // filtered_artworks () {
    //   var a = this.items
    //   var filtered = a
    //   var t = this
    //   this.filters.forEach(filter => {
    //     var filter_value = eval('t.' + filter)
    //     filtered = filtered.filter(record => {
    //       return filter === 'accession_number'
    //         ? new RegExp(filter_value, 'i').test(record[filter])
    //         : filter_value.some(r=> record[filter].includes(r))
    //     })
    //   })
    //   this.$store.dispatch('postFilterResults', filtered)
    //   return filtered
    // }
  },
  // mounted() {},
  created() {
    this.ownerships = Object.assign([], this.$store.getters.my_ownerships)
    // console.log(this.ownerships)
    this.ownerships.unshift({ id: 'all', name: 'All' })
    // this.locations = Object.assign(
    //   [],
    //   this.$store.getters.current_locations
    // ).sort(dynamicSort('name'))
    this.$emit('switchOwnershipTop')
    this.selected = Object.assign(
      [],
      this.ids2o(this.$store.state.currentSelection)
    )
    serverBus.$on('clearCurrentSelection', (a) => {
      this.selected = []
    })
    this.addAllShownArtworksToCurrentSelectionHandler = () => this.addFilteredToSelection()
    serverBus.$on(
      'addAllShownArtworksToCurrentSelection',
      this.addAllShownArtworksToCurrentSelectionHandler
    )
    // },
    // created: function() {
    // this.getArtists()
    // this.initialize();
    // this.filtered = this.artists;
    serverBus.$on('setSorting', (a) => {
      // console.log('receive')
      // console.log(a)
      this.p.sortBy = a
      this.p.descending = !this.p.descending
    })
    this.setSearchValue()
    this.setPageNumberValue()
    if (this.$route.fullPath === '/artworks/ownership/deaccession') {
      if (this.$store.state.filters['deaccession']) {
        // console.log('created store deacc')
        this.selectedOwnership = this.ownerships.find(
          (o) => o.id === this.$store.state.filters['deaccession']
        )
      } else {
        // console.log('created no store deacc')
        this.selectedOwnership = { id: 'all', name: 'All' }
      }
    } else {
      // console.log('not in deacc')
      this.selectedOwnership = { id: 'all', name: 'All' }
    }
    // this.toggleOwnership(this.ownerships[0])
  },
  beforeDestroy() {
    serverBus.$off(
      'addAllShownArtworksToCurrentSelection',
      this.addAllShownArtworksToCurrentSelectionHandler
    )
    this.resetNetxReview()
  },
  components: {
    TagFilter,
    LocationChangeDialog,
    AttachTagToArtworksDialog,
    ArtworkFilterMenu,
    ArtworkRowViewMenu,
    ArtworkTextRowDetails,
    ArtworkTextDrawer,
    ArtworkNetxRowDetails,
    IndexLoadState,
  },
}
</script>

<style scoped>
.redBorder {
  border: solid red 3px;
}

.series-indicator {
  color: #555;
  vertical-align: text-bottom;
}

.series-indicator--gallery {
  color: #fff;
  opacity: 0.78;
}

.on-view-indicator {
  color: #2e7d32;
  vertical-align: text-bottom;
}

.on-view-indicator--gallery {
  color: #b9f6ca;
  opacity: 0.95;
}

/* td {height: 120px !important;} */
a {
  text-decoration: none;
  color: #222;
}

a:hover {
  text-decoration: underline;
  color: #000;
}

/*.hoverDetect:hover img {
    -webkit-transform: scale(3);
    -moz-transform: scale(3);
    -ms-transform: scale(3);
    transform: scale(3); */
/* -webkit-transition: -webkit-transform .1s ease-out;
    -webkit-transition: transform .1s ease-out;
    -moz-transition: transform .1s ease-out;
    transition: transform .1s ease-out; */
/* } */
.carda {
  /* background: #F5F5F5; */
  padding: 5px;
  display: inline-block;
  margin: 0 0 0.2em;
  width: 100%;
  /* cursor: pointer; */
  transition: all 100ms ease-in-out;
}

/* .carda:hover { */
/* transform: translateY(-0.5em); */
/* background: #EBEBEB; */
/* } */
img {
  display: block;
  width: 100%;
}

/* v-card--reveal {
    align-items: center;
    bottom: 0;
    justify-content: center;
    opacity: .5;
    position: absolute;
    width: 100%;
  }
  .accent--text {
    color: #000000 !important;
    caret-color: #000 !important;
  } */
.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: height, opacity;
  transition-timing-function: ease;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/artworks/ArtworksTable.vue